/* eslint-disable max-len */
import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/es/components/Icon';
import classNames from 'classnames';
import React, { CSSProperties, MouseEventHandler, SVGProps } from 'react';
import styles from './Icons.module.scss';
import { GoToIconSvg } from './GoToIcon';

export { AgeIcon } from './AgeIcon';
export { AlertColoredIcon } from './alert-colored-icon/alert-colored-icon';
export { ApparelIcon, ApparelIconSvg } from './ApparelIcon';
export { BillboardIcon } from './BillboardIcon';
export { CannibalizationPurpleIcon } from './CannibalizationPurpleIcon';
export { CannibalizationIcon } from './CannibalizationIcon';
export { CasinoIcon } from './CasinoIcon';
export { CloseIcon } from './CloseIcon';
export { CoinIcon } from './CoinIcon';
export { CustomIcon } from './CustomIcon';
export { CommentIcon } from './CommentIcon';
export { DashboardIcon } from './DashboardIcon';
export { DemographicsPurpleIcon } from './DemographicsPurpleIcon';
export { DesktopOutlinedIcon } from './DesktopOutlined';
export { DiningIcon, DiningIconSvg } from './DiningIcon';
export { EditOutlinedIcon } from './EditOutlined';
export { EducationIcon, EducationIconSingleColorSvg } from './EducationIcon';
export { ElectronicsIcon, ElectronicsIconSvg } from './ElectronicsIcon';
export { EnvelopeIcon } from './EnvelopeIcon';
export { EnvelopeIconOutlined } from './EnvelopeIconOutlined';
export { EthnicityIcon } from './EthnicityIcon';
export { ExpandOutlinedIcon } from './ExpandOutlined';
export { ExploreIcon } from './ExploreIcon';
export { FacebookIcon } from './FacebookIcon';
export { FitnessIcon, FitnessIconSvg } from './FitnessIcon';
export { GroceriesIcon, GroceriesIconSvg } from './GroceriesIcon';
export { HelpOutlinedIcon } from './HelpOutlined';
export { HomeImprovementIcon, HomeImprovementIconSvg } from './HomeImprovementIcon';
export { HotelIcon, HotelIconSvg } from './HotelIcon';
export { HouseIcon } from './HouseIcon';
export { LeisureIcon, LeisureIconSvg } from './LeisureIcon';
export { LineChartIcon } from './LineChartIcon';
export { LinkedInIcon } from './LinkedInIcon';
export { LocationPurpleIcon } from './LocationPurpleIcon';
export { MedicalAndHealthIcon, MedicalAndHealthIconSvg } from './MedicalAndHealthIcon';
export { MenuIcon } from './MenuIcon';
export { NearestLocationPurpleIcon } from './NearestLocationPurpleIcon';
export { OfficeSuppliesIcon, OfficeSuppliesIconSvg } from './OfficeSuppliesIcon';
export { OverviewPurpleIcon } from './OverviewPurpleIcon';
export { PinIcon } from './PinIcon';
export { PinAreaIcon } from './PinAreaIcon';
export { PlacerLogo } from './PlacerLogo';
export { RadarChartIcon } from './RadarChartIcon';
export { SettingsIcon } from './SettingsIcon';
export { ShareIcon } from './ShareIcon';
export { ShopAndServiceIcon, ShopAndServiceIconSvg } from './ShopAndServiceIcon';
export { ShoppingCenterIcon, ShoppingCenterIconSvg } from './ShoppingCenterIcon';
export { SpaAndBeautyIcon, SpaAndBeautyIconSvg } from './SpaAndBeautyIcon';
export { SuperstoresIcon, SuperstoresIconSvg } from './SuperstoresIcon';
export { TagIcon } from './TagIcon';
export { TravelIcon, TravelIconSvg } from './TravelIcon';
export { TwitterIcon } from './TwitterIcon';
export { VenuePurpleIcon } from './VenuePurpleIcon';
export { VisitsPurpleIcon } from './VisitsPurpleIcon';
export { PieIcon } from './PieIcon';
export { StackChartIcon } from './StackChart';
export { TenantsIcon } from './TenantsIcon';
export { VenueIcon } from './VenueIcon';
export { CrimeArrestIcon, BorderedCrimeArrestSvg } from './CrimeArrestIcon';
export { CrimeAssaultIcon, BorderedCrimeAssaultSvg } from './CrimeAssaultIcon';
export { CrimeBurglaryIcon, BorderedCrimeBurglarySvg } from './CrimeBurglaryIcon';
export { CrimeOtherIcon, BorderedCrimeOtherSvg } from './CrimeOtherIcon';
export { CrimeRobberyIcon, CrimeRobberySvg } from './CrimeRobberyIcon';
export { CrimeShootingIcon, BorderedCrimeShootingSvg } from './CrimeShootingIcon';
export { CrimeTheftIcon, CrimeTheftSvg } from './CrimeTheftIcon';
export { CrimeVandalismIcon, BorderedCrimeVandalismSvg } from './CrimeVandalismIcon';
export { DistanceIcon } from './DistanceIcon';
export { PropertyInfoIcon } from './PropertyInfoIcon';
export { MapViewIcon } from './MapViewIcon';
export { ListIcon } from './ListIcon';
export { ZoomInIcon } from './ZoomInIcon';
export { BarChartCumulativeIcon } from './BarChartCumulative';
export { BarChartAggregatedIcon } from './BarChartAggregated';
export { CodeIcon } from './CodeIcon';
export { EnvelopeCheckIcon } from './EnvelopeCheckIcon';
export { EnvelopeXIcon } from './EnvelopeXIcon';
export { ThinCheckIcon } from './ThinCheckIcon';
export { WideCheckIcon } from './WideCheckIcon';
export { MapIcon } from './MapIcon';
export { SentMailIcon } from './SentMailIcon';
export { SentMailFailedIcon } from './SentMailFailedIcon';
export { AirportFacilitiesIcon } from './AirportFacilitiesIcon';
export { AttractionsIcon } from './AttractionsIcon';
export { BanksAndFinancialServicesIcon } from './BanksAndFinancialServicesIcon';
export { BarsAndPubsIcon } from './BarsAndPubsIcon';
export { ClothingIcon } from './ClothingIcon';
export { CoffeeAndBakeriesAndDessertShopsIcon } from './CoffeeAndBakeriesAndDessertShopsIcon';
export { DepartmentStoresIcon } from './DepartmentStoresIcon';
export { DiscountAndDollarStoresIcon } from './DiscountAndDollarStoresIcon';
export { DrugstoresAndPharmaciesIcon } from './DrugstoresAndPharmaciesIcon';
export { FashionAccessoriesIcon } from './FashionAccessoriesIcon';
export { FastFoodAndQSRIcon } from './FastFoodAndQSRIcon';
export { GasStationsAndConvenienceStoresIcon } from './GasStationsAndConvenienceStoresIcon';
export { HobbiesAndGiftsAndCraftsIcon } from './HobbiesAndGiftsAndCraftsIcon';
export { IndustrialIcon } from './IndustrialIcon';
export { MedicalCentersAndServicesIcon } from './MedicalCentersAndServicesIcon';
export { RegionIcon } from './RegionIcon';
export { RestaurantsIcon } from './RestaurantsIcon';
export { ShippingAndStorageIcon } from './ShippingAndStorageIcon';
export { ShoppingDistrictIcon } from './ShoppingDistrictIcon';
export { StadiumsAndEventHallsIcon } from './StadiumsAndEventHallsIcon';
export { TheatersAndMusicVenuesIcon } from './TheatersAndMusicVenuesIcon';
export { FilterSettingsIcon } from './FilterSettingsIcon';
export { SiteSelectionSvgIcon } from './SiteSelectionIcon';
export { SiteSelectionGraySvgIcon } from './SiteSelectionIcon';
export { WaitIcon } from './WaitIcon';
export { FishEatingIcon } from './FishEatingIcon';
export { EyeIcon } from './EyeIcon/EyeIcon';
export { ResetIcon } from './ResetIcon/ResetIcon';
export { PersonaIcon } from './PersonaIcon/PersonaIcon';
export { UnorderedListIcon } from './UnorderedListIcon';
export { LongArrowIcon } from './LongArrowIcon/LongArrowIcon';
export { PhoneIcon } from './PhoneIcon';
export { MailIcon } from './MailIcon';
export { FishEatingFishIcon } from './FishEatingFishIcon';
export { GroupOfPeopleIcon } from './GroupOfPeopleIcon';
export { HouseInSquareIcon } from './HouseInSquareIcon';
export { CheckedToggleIcon } from './CheckedToggleIcon';
export { UncheckedToggleIcon } from './UnCheckedToggleIcon';
export { ContactPersonIcon } from './ContactPersonIcon';
export { LogoutIcon } from './LogoutIcon';
export { LoginAsIcon } from './LoginAsIcon';
export { BuildingIcon } from './BuildingIcon';
export { FavoriteHeartIcon } from './FavoriteHeartIcon';
export { AllSitesIcon } from './AllSitesIcon';
export { FiltersIcon } from './FiltersIcon';
export { FiltersSettingsIcon } from './FiltersSettingsIcon';
export { UpgradeBadgeIcon } from './UpgradeBadgeIcon';
export { TrafficPinBigIcon } from './TrafficPinBigIcon';
export { CheckIcon } from './CheckIcon';
export { DiamondIcon } from './DiamondIcon/DiamondIcon';
export { BarWithArrowUpIcon } from './BarWithArrowUpIcon';
export { RankingColorIcon } from './RankingColorIcon';
export { ArrowSignIcon } from './ArrowSignIcon';
export { UtilityIcon } from './UtilityIcon';
export { SimilarityIcon } from './SimilarityIcon';
export { WeatherBlizzardIcon } from './weather-icons/weather-blizzard-icon/weather-blizzard-icon';
export { WeatherFogIcon } from './weather-icons/weather-fog-icon/weather-fog-icon';
export { WeatherCloudyIcon } from './weather-icons/weather-cloudy-icon/weather-cloudy-icon';
export { WeatherHeavyRainIcon } from './weather-icons/weather-heavy-rain-icon/weather-heavy-rain-icon';
export { WeatherLightRainIcon } from './weather-icons/weather-light-rain-icon/weather-light-rain-icon';
export { WeatherLightSnowWithThunderIcon } from './weather-icons/weather-light-snow-with-thunder-icon/weather-light-snow-with-thunder-icon';
export { WeatherPossibleRainWithThunderIcon } from './weather-icons/weather-possible-rain-with-thunder-icon/weather-possible-rain-with-thunder-icon';
export { WeatherPartlyCloudyIcon } from './weather-icons/weather-partly-cloudy-icon/weather-partly-cloudy-icon';
export { WeatherRainPossibleIcon } from './weather-icons/weather-rain-possible-icon/weather-rain-possible-icon';
export { WeatherSleetIcon } from './weather-icons/weather-sleet-icon/weather-sleet-icon';
export { WeatherSleetSnowPossibleIcon } from './weather-icons/weather-sleet-snow-possible-icon/weather-sleet-snow-possible-icon';
export { WeatherSnowIcon } from './weather-icons/weather-snow-icon/weather-snow-icon';
export { WeatherSnowPossibleIcon } from './weather-icons/weather-snow-possible-icon/weather-snow-possible-icon';
export { WeatherSnowWithThunderIcon } from './weather-icons/weather-snow-with-thunder-icon/weather-snow-with-thunder-icon';
export { WeatherSunnyIcon } from './weather-icons/weather-sunny-icon/weather-sunny-icon';
export { WeatherThunderstormIcon } from './weather-icons/weather-thunderstorm-icon/weather-thunderstorm-icon';
export { OwlAssistIcon } from './OwlAssistIcon';
export { LampIcon } from './LampIcon';
export { InsightsIcon } from './InsightsIcon';
export { HolidaysChristianIcon } from './holiday-icons/HolidaysChristianIcon';
export { HolidaysFederalIcon } from './holiday-icons/HolidaysFederalIcon';
export { HolidaysLocalTimezoneIcon } from './holiday-icons/HolidaysLocalTimezoneIcon';
export { HolidaysObservanceIcon } from './holiday-icons/HolidaysObservanceIcon';
export { ChevronRightIcon } from './ChevronRightIcon';
export { HolidaysSportIcon } from './holiday-icons/HolidaysSportIcon';
export { CoverageIcon } from './CoverageIcon/CoverageIcon';
export { ArrowIcon } from './ArrowIcon';
export { AddSiteIcon } from './AddSiteIcon';
export { VisitDurationIcon } from './visit-duration-icon/visit-duration-icon';
export { TwoLocationWithCircleIcon } from './TwoLocationWithCircleIcon';
export { AddedSitePoiIcon } from './AddedSitePoiIcon';
export { ApproveAlertIcon } from './ApproveAlertIcon';
export { EmptySpacePoiIcon } from './EmptySpacePoiIcon';
export { BarChartWithUpArrowIcon } from './BarChartWithUpArrowIcon';
export { BarChartWithQuestionMarkIcon } from './BarChartWithQuestionMarkIcon';
export { BarChartWithDollarSignIcon } from './BarChartWithDollarSignIcon';
export { EventsCalendarIcon } from './EventsCalendarIcon';
export { FestivalIcon } from './FestivalIcon';
export { PerformingArtsIcon } from './PerformingArtsIcon';
export { ExpoIcon } from './ExpoIcon';
export { CommunitiesIcon } from './CommunitiesIcon';
export { MusicIcon } from './MusicIcon';
export { SoccerGameIcon } from './SoccerGameIcon';
export { ManInMarkerIcon } from './ManInMarkerIcon';
export { GisMapBlueIcon } from './GisMapBlueIcon';
export { LocationPinIcon } from './LocationPinIcon';
export { LocationPinWithShadowIcon } from './LocationPinWithShadowIcon';
export { SuggestionsIcon } from './SuggestionsIcon';
export { SelfCompareIcon } from './SelfCompareIcon';
export { ArrowsFiveFromIcon } from './ArrowsFiveFromIcon';
export { ArrowsFiveToIcon } from './ArrowsFiveToIcon';
export { ArrowsThreeFromIcon } from './ArrowsThreeFromIcon';
export { ArrowsThreeToIcon } from './ArrowsThreeToIcon';
export { ClockCountDownIcon } from './ClockCountDownIcon';
export { PinPromotionIcon } from './PinPromotionIcon';
export { CreatePoiIcon } from './CreatePoiIcon';
export { AnalogIcon } from './AnalogIcon';

const OwlLogo = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg width="33px" height="47px" viewBox="0 0 33 47" version="1.1" {...props}>
        <g
            id="Explore_final_with_icons"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g id="Header" fill="#5E63E5">
                <g id="Logo_icon">
                    <path
                        d="M10.5002,18.0002 C9.6712,18.0002 9.0002,17.3282 9.0002,16.5002 L9.0002,13.5002 C9.0002,12.6722 9.6712,12.0002 10.5002,12.0002 C11.3282,12.0002 12.0002,12.6722 12.0002,13.5002 L12.0002,16.5002 C12.0002,17.3282 11.3282,18.0002 10.5002,18.0002"
                        id="Fill-1"
                    ></path>
                    <path
                        d="M22.5002,18.0002 C21.6712,18.0002 21.0002,17.3282 21.0002,16.5002 L21.0002,13.5002 C21.0002,12.6722 21.6712,12.0002 22.5002,12.0002 C23.3282,12.0002 24.0002,12.6722 24.0002,13.5002 L24.0002,16.5002 C24.0002,17.3282 23.3282,18.0002 22.5002,18.0002"
                        id="Fill-3"
                    ></path>
                    <path
                        d="M16.5002,27.0002 C10.1482,27.0002 5.0002,21.5842 5.0002,14.9022 C5.0002,13.7682 5.1522,12.6712 5.4292,11.6302 L5.4292,11.7092 C6.0682,9.5612 7.9722,8.0002 10.2262,8.0002 C13.0022,8.0002 15.0002,10.3682 15.0002,13.2892 L15.0002,16.8182 L15.0002,18.0002 L15.0002,18.8482 C15.0002,19.6682 15.6652,20.3332 16.4852,20.3332 L16.5152,20.3332 C17.3352,20.3332 18.0002,19.6682 18.0002,18.8482 L18.0002,18.0002 L18.0002,16.8182 L18.0002,13.2892 C18.0002,10.3682 19.9972,8.0002 22.7742,8.0002 C25.0282,8.0002 26.9322,9.5612 27.5712,11.7102 L27.5712,11.6302 C27.8482,12.6712 28.0002,13.7682 28.0002,14.9022 C28.0002,21.5842 22.8512,27.0002 16.5002,27.0002 Z M21.0002,31.5022 C21.0002,32.3292 20.3292,33.0002 19.5022,33.0002 L19.4982,33.0002 C18.6702,33.0002 18.0002,32.3292 18.0002,31.5022 L18.0002,30.8512 C18.0002,30.7982 18.0702,30.7862 18.0882,30.8362 C18.2962,31.4132 18.8492,31.8262 19.4982,31.8262 L19.5022,31.8262 C20.1512,31.8262 20.7032,31.4132 20.9122,30.8362 C20.9292,30.7862 21.0002,30.7982 21.0002,30.8512 L21.0002,31.5022 Z M18.0002,34.5022 C18.0002,35.3292 17.3292,36.0002 16.5022,36.0002 L16.4982,36.0002 C15.6702,36.0002 15.0002,35.3292 15.0002,34.5022 L15.0002,33.8512 C15.0002,33.7982 15.0702,33.7862 15.0882,33.8362 C15.2962,34.4132 15.8492,34.8262 16.4982,34.8262 L16.5022,34.8262 C17.1512,34.8262 17.7032,34.4132 17.9122,33.8362 C17.9292,33.7862 18.0002,33.7982 18.0002,33.8512 L18.0002,34.5022 Z M13.5022,33.0002 L13.4982,33.0002 C12.6702,33.0002 12.0002,32.3292 12.0002,31.5022 L12.0002,30.8512 C12.0002,30.7982 12.0702,30.7862 12.0882,30.8362 C12.2962,31.4132 12.8492,31.8262 13.4982,31.8262 L13.5022,31.8262 C14.1512,31.8262 14.7032,31.4132 14.9122,30.8362 C14.9292,30.7862 15.0002,30.7982 15.0002,30.8512 L15.0002,31.5022 C15.0002,32.3292 14.3292,33.0002 13.5022,33.0002 Z M30.2652,6.5372 L30.9082,3.0002 L24.8512,3.0002 C21.0412,3.0002 17.7952,5.3832 16.5002,8.7352 C15.2052,5.3832 11.9582,3.0002 8.1482,3.0002 L2.0922,3.0002 L2.7352,6.5372 C0.9722,9.0742 0.0002,12.2082 0.0002,15.7122 C0.0002,31.8282 16.5002,42.0002 16.5002,42.0002 C16.5002,42.0002 33.0002,31.8282 33.0002,15.7122 C33.0002,12.2082 32.0282,9.0742 30.2652,6.5372 Z"
                        id="Fill-5"
                    ></path>
                    <path
                        d="M23.0002,46.0002 C23.0002,46.5522 20.0902,47.0002 16.5002,47.0002 C12.9102,47.0002 10.0002,46.5522 10.0002,46.0002 C10.0002,45.4472 12.9102,45.0002 16.5002,45.0002 C20.0902,45.0002 23.0002,45.4472 23.0002,46.0002"
                        id="Fill-8"
                    ></path>
                    <path
                        d="M16.5002,6.3205 C18.0712,3.7335 20.9062,2.0005 24.1542,2.0005 L25.1192,2.0005 C22.7012,0.7235 19.8032,0.0005 16.5002,0.0005 C13.1972,0.0005 10.2992,0.7235 7.8812,2.0005 L8.8462,2.0005 C12.0942,2.0005 14.9292,3.7335 16.5002,6.3205"
                        id="Fill-11"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
);

const ChainsIconRoundSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="52" height="52" viewBox="-1 -1 53 53">
        <g fill="none" fillRule="evenodd" transform="translate(1 1)">
            <circle cx="25" cy="25" r="25" stroke="#3E4394" opacity=".4" />
            <g>
                <path
                    stroke="#3E4394"
                    d="M13 3.5L17.5 3.5 17.5 10M8 18.5L2.5 18.5 2.5 12"
                    transform="translate(15 14)"
                />
                <path
                    fill="#3E4394"
                    d="M10 2H0v8h8c1.104 0 2-.896 2-2V2zM9 3v5c0 .552-.449 1-1 1H1V3h8z"
                    transform="translate(15 14)"
                />
                <path
                    fill="#FFF"
                    d="M3 5.5C1.622 5.5.5 4.379.5 3V.5h5V3c0 1.379-1.122 2.5-2.5 2.5"
                    transform="translate(15 14)"
                />
                <path
                    fill="#3E4394"
                    d="M6 0H0v3c0 1.657 1.343 3 3 3s3-1.343 3-3V0zM5 1v2c0 1.103-.897 2-2 2s-2-.897-2-2V1h4z"
                    transform="translate(15 14)"
                />
                <path
                    fill="#FFF"
                    d="M8 5.5C6.622 5.5 5.5 4.379 5.5 3V.5H9c.827 0 1.5.673 1.5 1.5v1c0 1.379-1.122 2.5-2.5 2.5"
                    transform="translate(15 14)"
                />
                <path
                    fill="#3E4394"
                    d="M9 0H5v3c0 1.657 1.343 3 3 3s3-1.343 3-3V2c0-1.104-.896-2-2-2m0 1c.551 0 1 .448 1 1v1c0 1.103-.897 2-2 2s-2-.897-2-2V1h3M6 7L5 7 4 7 4 8 4 10 5 10 5 8 6 8 6 10 7 10 7 8 7 7z"
                    transform="translate(15 14)"
                />
                <g>
                    <path
                        fill="#3E4394"
                        d="M11 2H1v6c0 1.104.896 2 2 2h8V2zm-1 1v6H3c-.551 0-1-.448-1-1V3h8z"
                        transform="translate(15 14) translate(9 12)"
                    />
                    <path
                        fill="#FFF"
                        d="M8 5.5C6.622 5.5 5.5 4.379 5.5 3V.5h5V3c0 1.379-1.122 2.5-2.5 2.5"
                        transform="translate(15 14) translate(9 12)"
                    />
                    <path
                        fill="#3E4394"
                        d="M11 0H5v3c0 1.657 1.343 3 3 3s3-1.343 3-3V0zm-1 1v2c0 1.103-.897 2-2 2s-2-.897-2-2V1h4z"
                        transform="translate(15 14) translate(9 12)"
                    />
                    <path
                        fill="#FFF"
                        d="M3 5.5C1.622 5.5.5 4.379.5 3V2C.5 1.173 1.173.5 2 .5h3.5V3c0 1.379-1.122 2.5-2.5 2.5"
                        transform="translate(15 14) translate(9 12)"
                    />
                    <path
                        fill="#3E4394"
                        d="M6 0H2C.896 0 0 .896 0 2v1c0 1.657 1.343 3 3 3s3-1.343 3-3V0zM5 1v2c0 1.103-.897 2-2 2s-2-.897-2-2V2c0-.552.449-1 1-1h3zM5 7L6 7 7 7 7 8 7 10 6 10 6 8 5 8 5 10 4 10 4 8 4 7z"
                        transform="translate(15 14) translate(9 12)"
                    />
                </g>
            </g>
        </g>
    </svg>
);

const CalendarIconRoundSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="52" height="52" viewBox="-1 -1 53 53">
        <g fill="none" fillRule="evenodd" transform="translate(1 1)">
            <circle cx="25" cy="25" r="25" stroke="#3E4394" strokeWidth=".938" opacity=".4" />
            <g>
                <path
                    stroke="#3E4394"
                    strokeLinecap="round"
                    d="M3.853 12.12L6.074 12.12M8.922 12.12L11.144 12.12M13.991 12.12L16.213 12.12M3.853 16.9L6.074 16.9M8.922 16.9L11.144 16.9M13.991 16.9L16.213 16.9"
                    transform="translate(15 14)"
                />
                <path
                    fill="#3E4394"
                    d="M18.889 1.611H1.112C.497 1.611 0 2.108 0 2.722V20.5c0 .614.497 1.111 1.112 1.111h17.777c.614 0 1.11-.497 1.11-1.11V2.721c0-.614-.496-1.11-1.11-1.11m0 1c.062 0 .11.05.11.11V20.5c0 .061-.048.111-.11.111H1.112c-.062 0-.112-.05-.112-.11V2.721c0-.06.05-.11.112-.11h17.777"
                    transform="translate(15 14)"
                />
                <path stroke="#3E4394" d="M0 8L20 8" transform="translate(15 14)" />
                <path
                    stroke="#3E4394"
                    strokeLinecap="round"
                    d="M8.333 6.055L11.667 6.055"
                    transform="translate(15 14)"
                />
                <path
                    stroke="#3E4394"
                    d="M5 4.388L5 .499M15 4.388L15 .499"
                    transform="translate(15 14)"
                />
            </g>
        </g>
    </svg>
);

const DialogReportIconRoundSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="52" height="52" viewBox="-1 -1 53 53">
        <g fill="none" fillRule="evenodd" stroke="#3E4394" transform="translate(1 1)">
            <circle cx="25" cy="25" r="25" opacity=".4" />
            <g>
                <path
                    strokeLinecap="round"
                    d="M1.719 22.031H18.28c.692 0 1.25-.56 1.25-1.25V6.6L13.401.469H1.72c-.692 0-1.25.56-1.25 1.25V20.78c0 .69.559 1.25 1.25 1.25z"
                    transform="matrix(1 0 0 -1 15 36.25)"
                />
                <path
                    d="M10 16.875L5 16.875M10 6.875L5 6.875M15 14.375L5 14.375M15 11.875L5 11.875"
                    transform="matrix(1 0 0 -1 15 36.25)"
                />
                <path
                    fill="#FFF"
                    strokeLinecap="round"
                    d="M13.401.469l6.13 6.131v.296h-5.177c-.647 0-1.18-.492-1.243-1.122l-.007-.128V.47h.297z"
                    transform="matrix(1 0 0 -1 15 36.25)"
                />
            </g>
        </g>
    </svg>
);

const ReportIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="16" height="18" viewBox="0 0 16 18">
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g>
                            <path
                                stroke="#49565D"
                                strokeWidth=".75"
                                d="M15 .375L15.625 17l-9.21.625-5.857-5.597L.375 1 15 .375z"
                                transform="translate(-1140 -440) translate(1127 422) translate(12 18) translate(1)"
                            />
                            <path
                                fill="#D0D0D0"
                                d="M1 12L6 12 6 17z"
                                transform="translate(-1140 -440) translate(1127 422) translate(12 18) translate(1)"
                            />
                            <path
                                fill="#49565D"
                                fillRule="nonzero"
                                d="M5.5 11.5c.552 0 1 .448 1 1v4.793c0 .276-.224.5-.5.5-.133 0-.26-.053-.354-.147L.354 12.354c-.196-.196-.196-.512 0-.708.093-.093.22-.146.353-.146H5.5zm.25 5.19V12.5c0-.118-.082-.217-.193-.243L5.5 12.25H1.31l4.44 4.44z"
                                transform="translate(-1140 -440) translate(1127 422) translate(12 18) translate(1)"
                            />
                            <g fill="#49565D">
                                <path
                                    d="M5 4.875L6 4.875 6 4.125 5 4.125zM7 4.875L10 4.875 10 4.125 7 4.125zM7 2.875L10 2.875 10 2.125 7 2.125zM0 2.875L6 2.875 6 2.125 0 2.125zM0 .875L1 .875 1 .125 0 .125zM2 .875L10 .875 10 .125 2 .125z"
                                    transform="translate(-1140 -440) translate(1127 422) translate(12 18) translate(1) translate(3 3)"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const HeartSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg width="1em" {...props} height="1em" fill="currentColor" viewBox="0 0 1024 1024">
        <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
);

const SelectArrow = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="10" height="6" viewBox="0 0 10 6">
        <path
            fill="none"
            fillRule="evenodd"
            stroke="#333"
            strokeLinejoin="bevel"
            strokeWidth="2"
            d="M1 1l3.321 3.565c.375.402.993.4 1.376-.002L9 1.099"
        />
    </svg>
);

const SelectArrowLight = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            width="6"
            height="10"
            viewBox="0 0 6 10"
            fill="none"
        >
            <path
                d="M0 9.1496L4.58088 5.33866C4.79027 5.16446 4.81821 4.91684 4.66258 4.72198L4.58464 4.64206L0.121383 0.841461L0.960529 -3.94994e-07L5.42378 3.8006C6.15305 4.42159 6.18851 5.41398 5.53918 6.07014L5.40941 6.18906L0.82853 10L0 9.1496Z"
                fill="#49565D"
            />
        </svg>
    );
};

const SmallSelectArrow = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="9" height="4" viewBox="0 0 9 4">
        <path
            fill="none"
            fillRule="evenodd"
            stroke="#4D4D4D"
            strokeWidth=".875"
            d="M1 0l3.099 3.343c.221.24.58.246.802.01L8 .087"
        />
    </svg>
);

const Download = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="16" height="18" viewBox="0 0 16 18">
        <g fill="none" fillRule="evenodd">
            <path fill="#D0D0D0" d="M10.483.375v4.142c0 .551.448 1 1 1h4.142" />
            <path
                stroke="#49565D"
                strokeLinecap="round"
                strokeWidth=".75"
                d="M10.483.375v4.142c0 .551.448 1 1 1h4.142"
            />
            <path
                stroke="#49565D"
                strokeLinecap="round"
                strokeWidth=".75"
                d="M1.375 17.625h13.25a1 1 0 0 0 1-1V5.279L10.721.375H1.375a1 1 0 0 0-1 1v15.25a1 1 0 0 0 1 1z"
            />
            <path
                stroke="#49565D"
                strokeWidth=".75"
                d="M8 5.725v5.859M10.291 9.552L8 11.842l-2.291-2.29M10.93 13.824H5.071"
            />
        </g>
    </svg>
);

const Lock = ({
    fill = '#FFFFFF',
    height = 16,
    width = 13,
    ...props
}: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        width={width}
        height={height}
        viewBox="0 0 13 16"
    >
        <g fill="none" fillRule="evenodd">
            <path fill="#FFF" d="M10.5 4.375a4 4 0 0 0-8 0v4h2v-4a2 2 0 0 1 4 0v4h2v-4z" />
            <path
                stroke="currentColor"
                strokeWidth=".75"
                d="M10.5 4.375a4 4 0 0 0-8 0v4h2v-4a2 2 0 0 1 4 0v4h2v-4z"
            />
            <path
                fill={fill}
                d="M1.236 15.5a.863.863 0 0 1-.86-.862V8.112c0-.475.385-.862.86-.862h10.527c.475 0 .862.387.862.862v6.526a.863.863 0 0 1-.862.862H1.236z"
            />
            <path
                fill="currentColor"
                d="M11.764 6.875H1.237C.554 6.875 0 7.429 0 8.112v6.526c0 .683.554 1.237 1.237 1.237h10.527c.683 0 1.236-.554 1.236-1.237V8.112c0-.683-.553-1.237-1.236-1.237m0 .75c.268 0 .486.218.486.487v6.526a.487.487 0 0 1-.486.487H1.237a.488.488 0 0 1-.487-.487V8.112c0-.269.219-.487.487-.487h10.527"
            />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeWidth=".75"
                d="M9.5 11.375h3M9.5 13.375h3M9.5 9.375h3"
            />
        </g>
    </svg>
);

const Help = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="22" height="22" viewBox="0 0 22 22">
        <g fill="none" fillRule="evenodd">
            <rect width="22" height="22" fill="#F2F2F2" rx="2" />
            <path
                fill="#49565D"
                fillRule="nonzero"
                d="M11.103 12.965v-.308c0-.369.071-.663.215-.882.143-.218.427-.494.85-.827.498-.387.847-.702 1.05-.943.203-.242.355-.496.455-.762.1-.267.15-.571.15-.913 0-.77-.262-1.374-.786-1.811-.524-.438-1.233-.657-2.126-.657a6.018 6.018 0 0 0-2.973.773l.574 1.203c.35-.173.71-.321 1.08-.444.369-.123.77-.185 1.203-.185.478 0 .845.103 1.1.308.256.205.383.499.383.881 0 .329-.078.611-.236.848-.157.237-.507.57-1.049.998-.456.356-.775.7-.957 1.032-.182.333-.273.75-.273 1.251v.438h1.34zm-.616 3.233c.324 0 .573-.094.749-.283.175-.19.263-.446.263-.77 0-.328-.087-.582-.26-.762-.173-.18-.424-.27-.752-.27-.67 0-1.005.344-1.005 1.033 0 .332.087.59.26.775.173.185.422.277.745.277z"
            />
        </g>
    </svg>
);

const Location = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        {...props}
        width="14"
        height="18"
        viewBox="0 0 14 18"
        xmlns="http://www.w3.org/2000/svg"
        fill="inherit"
    >
        <g strokeWidth=".75" fill="inherit" fillRule="evenodd" stroke="inherit">
            <path d="M2.6577,17.625 L10.6577,17.625" stroke="inherit" />
            <path
                d="M6.67.375c3.463 0 6.27 2.808 6.27 6.27 0 1.617-.547 2.935-1.623 4.198-1.074 1.262-4.66 4.407-4.66 4.407s-3.586-3.145-4.66-4.407C.922 9.58.375 8.262.375 6.645c0-3.462 2.807-6.27 6.27-6.27h.025z"
                fill="inherit"
                stroke="#49565D"
                strokeLinecap="round"
            />
            <path
                d="M9.05 6.56c0 1.322-1.072 2.393-2.393 2.393-1.32 0-2.39-1.071-2.39-2.392 0-1.32 1.07-2.393 2.39-2.393 1.321 0 2.392 1.072 2.392 2.393z"
                stroke="#49565D"
                strokeLinecap="round"
                fill="#FFF"
            />
        </g>
    </svg>
);

const LocationOutlineSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
        <g fill="none" fillRule="evenodd">
            <g strokeWidth=".75">
                <g>
                    <g>
                        <g>
                            <g>
                                <g>
                                    <path
                                        stroke="#676DFD"
                                        d="M2.658 17.625L10.658 17.625"
                                        transform="translate(-80 -430) translate(40 171) translate(0 180) translate(40 78) translate(0 1) translate(2)"
                                    />
                                    <path
                                        stroke="#49565D"
                                        strokeLinecap="round"
                                        d="M6.67.375c3.463 0 6.27 2.808 6.27 6.27 0 1.617-.547 2.935-1.623 4.198-1.074 1.262-4.66 4.407-4.66 4.407s-3.586-3.145-4.66-4.407C.922 9.58.375 8.262.375 6.645c0-3.462 2.807-6.27 6.27-6.27h.025z"
                                        transform="translate(-80 -430) translate(40 171) translate(0 180) translate(40 78) translate(0 1) translate(2)"
                                    />
                                    <path
                                        fill="#FFF"
                                        stroke="#49565D"
                                        strokeLinecap="round"
                                        d="M9.05 6.56c0 1.322-1.072 2.393-2.393 2.393-1.32 0-2.39-1.071-2.39-2.392 0-1.32 1.07-2.393 2.39-2.393 1.321 0 2.392 1.072 2.392 2.393z"
                                        transform="translate(-80 -430) translate(40 171) translate(0 180) translate(40 78) translate(0 1) translate(2)"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const BarChart = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="17" height="18" viewBox="0 0 17 18">
        <g fill="none" fillRule="evenodd" stroke="#49565D" strokeWidth=".75">
            <rect width="7.25" height="17.25" x=".375" y=".375" fill="#D0D0D0" rx="1" />
            <rect width="6.25" height="10.25" x="10.375" y="7.375" fill="#FFF" rx="1" />
        </g>
    </svg>
);

const PieChart = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="18" height="18" viewBox="0 0 18 18">
        <g fill="none" fillRule="evenodd">
            <path
                fill="#49565D"
                d="M7.497 3.01c-1.994.104-3.845 1.033-5.125 2.586C1.013 7.245.472 9.418.887 11.559c.54 2.78 2.771 5.012 5.551 5.552 2.14.415 4.314-.126 5.963-1.485 1.553-1.281 2.483-3.132 2.586-5.126H8.755c-.694 0-1.258-.564-1.258-1.257V3.01zm.36 14.988c-.518 0-1.04-.05-1.56-.151C3.217 17.249.748 14.78.15 11.702-.308 9.34.291 6.94 1.793 5.118c1.503-1.822 3.72-2.868 6.08-2.868.206 0 .374.168.374.375v6.618c0 .28.228.507.508.507h6.617c.207 0 .375.168.375.375 0 2.36-1.046 4.576-2.869 6.079-1.42 1.172-3.192 1.794-5.022 1.794z"
            />
            <path
                fill="#D0D0D0"
                d="M10.122.375v6.618c0 .487.396.882.883.882h6.617c0-4.142-3.357-7.5-7.5-7.5"
            />
            <path
                fill="#49565D"
                d="M10.497.76v6.233c0 .28.228.507.508.507h6.232c-.189-3.631-3.109-6.551-6.74-6.74m7.125 7.49h-6.617c-.694 0-1.258-.564-1.258-1.257V.375c0-.207.168-.375.375-.375 4.343 0 7.875 3.533 7.875 7.875 0 .207-.168.375-.375.375"
            />
        </g>
    </svg>
);

const CancelSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 14 14">
        <g fill="none" fillRule="evenodd" stroke="#49565D" strokeLinecap="round" strokeWidth="1.5">
            <path d="M11.662 11.662L0 0M0 11.662L11.662 0" transform="translate(1 1)" />
        </g>
    </svg>
);

const DropdownArrowSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="8" height="12" viewBox="0 0 8 12">
        <path
            fill="none"
            fillRule="evenodd"
            stroke="inherit"
            strokeWidth="2"
            d="M-2.5 2.5L2.5 7.5 7.5 2.615"
            transform="rotate(-90 3.5 5)"
        />
    </svg>
);

const SearchIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        width="100%"
        height="100%"
        viewBox="0 0 18 18"
    >
        <g fill="none" fillRule="evenodd">
            <path
                fill="#676DFD"
                d="M12.407 11.036l2.936 2.949c.373.372.373.978 0 1.35l-.008.008c-.373.373-.977.373-1.35 0l-2.936-2.95"
                transform="translate(1 1)"
            />
            <path
                stroke="#49565D"
                strokeLinecap="round"
                strokeWidth=".756"
                d="M12.407 11.036l2.936 2.949c.373.372.373.978 0 1.35l-.008.008c-.373.373-.977.373-1.35 0l-2.936-2.95"
                transform="translate(1 1)"
            />
            <path
                stroke="#49565D"
                strokeLinecap="round"
                strokeWidth=".756"
                d="M13.667 7c0 3.683-2.985 6.667-6.667 6.667S.333 10.683.333 7 3.318.333 7 .333 13.667 3.317 13.667 7zM3.543 3.543c1.91-1.909 5.004-1.909 6.914 0"
                transform="translate(1 1)"
            />
        </g>
    </svg>
);

const ClearSearchIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
    >
        <defs>
            <path id="prefix__a" d="M0 0L20 0 20 20 0 20z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <mask id="prefix__b" fill="#fff">
                <use xlinkHref="#prefix__a" />
            </mask>
            <path
                fill="#F2F2F2"
                d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10C0 4.478 4.477 0 10 0s10 4.478 10 10"
                mask="url(#prefix__b)"
            />
            <g stroke="#49565D" strokeLinecap="round" strokeWidth="1.5">
                <path d="M6.25 6.25L0 0M0 6.25L6.25 0" transform="translate(6.875 6.875)" />
            </g>
        </g>
    </svg>
);

const ChainIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16"
        height="16"
        viewBox="0 0 16 16"
    >
        <defs>
            <path id="prefix__a" d="M0 0L4.8 0 4.8 4.8 0 4.8z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <path
                stroke="#49565D"
                strokeWidth=".75"
                d="M10 2.5L13.5 2.5 13.5 7M7 14.5L2.5 14.5 2.5 9"
            />
            <path
                fill="#49565D"
                d="M8 2H0v6h6.451C7.307 8 8 7.307 8 6.451V2zm-.75.75v3.701c0 .441-.358.799-.799.799H.75v-4.5h6.5z"
            />
            <path
                fill="currentColor"
                d="M2.4 4.425C1.283 4.425.375 3.517.375 2.4V.375h4.05V2.4c0 1.116-.908 2.024-2.025 2.024"
            />
            <mask id="prefix__b" fill="#fff">
                <use xlinkHref="#prefix__a" />
            </mask>
            <path
                fill="#49565D"
                d="M4.8 0H0v2.4c0 1.326 1.075 2.4 2.4 2.4 1.326 0 2.4-1.074 2.4-2.4V0zm-.75.75V2.4c0 .91-.74 1.65-1.65 1.65-.91 0-1.65-.74-1.65-1.65V.75h3.3z"
                mask="url(#prefix__b)"
            />
            <path
                fill="currentColor"
                d="M6.4 4.425c-1.117 0-2.025-.908-2.025-2.024V.375H7.2c.676 0 1.225.55 1.225 1.225v.8c0 1.117-.908 2.025-2.025 2.025"
            />
            <path
                fill="#49565D"
                d="M7.2 0H4v2.4c0 1.326 1.075 2.4 2.4 2.4s2.4-1.074 2.4-2.4v-.8C8.8.717 8.083 0 7.2 0m0 .75c.468 0 .85.381.85.85v.8c0 .91-.74 1.65-1.65 1.65-.91 0-1.65-.74-1.65-1.65V.75H7.2M4.91 5.6H3.49c-.27 0-.49.22-.49.49v1.42c0 .27.22.49.49.49h1.42c.271 0 .49-.22.49-.49V6.09c0-.27-.219-.49-.49-.49zM3.75 7.25h.9v-.9h-.9v.9zM16 10H8v4.451C8 15.307 8.693 16 9.549 16H16v-6zm-.75.75v4.5H9.549c-.441 0-.799-.358-.799-.799V10.75h6.5z"
            />
            <path
                fill="currentColor"
                d="M13.6 12.425c-1.116 0-2.024-.908-2.024-2.024V8.375h4.049V10.4c0 1.116-.908 2.024-2.025 2.024"
            />
            <path
                fill="#49565D"
                d="M16 8h-4.8v2.4c0 1.326 1.074 2.4 2.4 2.4 1.326 0 2.4-1.074 2.4-2.4V8zm-.75.75v1.65c0 .91-.74 1.65-1.65 1.65-.91 0-1.65-.74-1.65-1.65V8.75h3.3z"
            />
            <path
                fill="currentColor"
                d="M9.6 12.425c-1.116 0-2.024-.908-2.024-2.024V9.6c0-.675.549-1.225 1.224-1.225h2.825V10.4c0 1.116-.908 2.024-2.025 2.024"
            />
            <path
                fill="#49565D"
                d="M12 8H8.8c-.883 0-1.6.717-1.6 1.6v.8c0 1.326 1.074 2.4 2.4 2.4 1.326 0 2.4-1.074 2.4-2.4V8zm-.75.75v1.65c0 .91-.74 1.65-1.65 1.65-.91 0-1.65-.74-1.65-1.65v-.8c0-.469.382-.85.85-.85h2.45zM12.51 13.6h-1.42c-.27 0-.49.22-.49.49v1.42c0 .27.22.49.49.49h1.42c.27 0 .49-.22.49-.49v-1.42c0-.27-.22-.49-.49-.49zm-1.16 1.65h.9v-.9h-.9v.9z"
            />
        </g>
    </svg>
);

const TrashBinIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="17" height="19" viewBox="0 0 17 19">
        <g fill="none" fillRule="evenodd">
            <path fill="#D0D0D0" d="M13.5 18.375a2 2 0 0 0 2-2v-12h-14v12a2 2 0 0 0 2 2" />
            <path
                stroke="#49565D"
                strokeLinecap="round"
                strokeWidth=".75"
                d="M13.5 18.375a2 2 0 0 0 2-2v-12h-14v12a2 2 0 0 0 2 2h10z"
            />
            <path
                stroke="#49565D"
                strokeWidth=".75"
                d="M17 2.375H0M17 4.375H0M8.5 6.875v9M5.5 15.875v-6M11.5 15.875v-6"
            />
            <path
                stroke="#49565D"
                strokeLinejoin="round"
                strokeWidth=".75"
                d="M5.5 2.375h6v-2h-6z"
            />
        </g>
    </svg>
);

const DotsMoreIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="3" height="17" viewBox="0 0 3 17">
        <g fill="#49565D" fillRule="evenodd">
            <circle cx="1.5" cy="1.5" r="1.5" />
            <circle cx="1.5" cy="8.5" r="1.5" />
            <circle cx="1.5" cy="15.5" r="1.5" />
        </g>
    </svg>
);

const CalendarIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 18 20"
        stroke={props.fill}
        className={styles.animation}
    >
        <g fillRule="evenodd">
            <path
                fill="#D0D0D0"
                stroke="none"
                d="M13.5 4.875c-.553 0-1-.448-1-1s.447-1 1-1c.553 0 1 .448 1 1s-.447 1-1 1m-9 0c-.553 0-1-.448-1-1s.447-1 1-1c.553 0 1 .448 1 1s-.447 1-1 1m12.5-3.5H1c-.553 0-1 .448-1 1v4.75h18v-4.75c0-.552-.447-1-1-1"
            />
            <path
                stroke="inherit"
                strokeLinecap="round"
                strokeWidth=".75"
                d="M3.467 10.834L5.467 10.834M8.029 10.834L10.029 10.834M12.592 10.834L14.592 10.834M3.467 15.135L5.467 15.135M8.029 15.135L10.029 15.135M12.592 15.135L14.592 15.135"
            />
            <path
                fill="inherit"
                stroke="none"
                d="M17 1.375H1c-.553 0-1 .448-1 1v16c0 .552.447 1 1 1h16c.553 0 1-.448 1-1v-16c0-.552-.447-1-1-1m0 .75c.138 0 .25.112.25.25v16c0 .138-.112.25-.25.25H1c-.138 0-.25-.112-.25-.25v-16c0-.138.112-.25.25-.25h16"
            />
            <path stroke="inherit" strokeWidth=".75" d="M0 7.125L18 7.125" />
            <path
                stroke="inherit"
                strokeLinecap="round"
                strokeWidth=".75"
                d="M7.5 5.375L10.5 5.375M4.5 3.875L4.5.375M13.5 3.875L13.5.375"
            />
        </g>
    </svg>
);

const PlusIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="18" height="18" viewBox="0 0 18 18">
        <g fill="currentColor" fillRule="evenodd">
            <rect width="2" height="18" x="8" rx="1" />
            <path d="M18 9a1 1 0 00-1-1H1a1 1 0 000 2h16a1 1 0 001-1z" />
        </g>
    </svg>
);

const PlusIconSvgThick = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="18" height="18" viewBox="0 0 18 18">
        <path fill="#666" d="M18 7h-7V0H7v7H0v4h7v7h4v-7h7z" />
    </svg>
);

const minusIconSvgThick = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="18" height="18" viewBox="0 0 18 18">
        <path fill="#333" d="M0 7h18v4H0V7z" />
    </svg>
);

const FilterIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="18" height="19" viewBox="0 0 18 19">
        <g fill="none" fillRule="evenodd">
            <path
                stroke="#49565D"
                strokeWidth=".75"
                d="M7.092 15.723L18 15.723M0 15.723L3.289 15.723"
            />
            <path
                fill="#B3B3B3"
                d="M3.29 15.723c0-1.05.85-1.902 1.9-1.902 1.05 0 1.902.852 1.902 1.902 0 1.05-.852 1.902-1.902 1.902-1.05 0-1.9-.852-1.9-1.902"
            />
            <path
                stroke="#49565D"
                strokeLinecap="round"
                strokeWidth=".75"
                d="M3.29 15.723c0-1.05.85-1.902 1.9-1.902 1.05 0 1.902.852 1.902 1.902 0 1.05-.852 1.902-1.902 1.902-1.05 0-1.9-.852-1.9-1.902z"
            />
            <path
                stroke="#49565D"
                strokeWidth=".75"
                d="M8.942 2.277L18 2.277M0 2.277L5.139 2.277"
            />
            <path
                fill="#B3B3B3"
                d="M5.139 2.277c0-1.05.852-1.901 1.9-1.901 1.052 0 1.904.85 1.904 1.9 0 1.05-.852 1.903-1.903 1.903-1.05 0-1.901-.852-1.901-1.902"
            />
            <path
                stroke="#49565D"
                strokeLinecap="round"
                strokeWidth=".75"
                d="M5.139 2.277c0-1.05.852-1.901 1.9-1.901 1.052 0 1.904.85 1.904 1.9 0 1.05-.852 1.903-1.903 1.903-1.05 0-1.901-.852-1.901-1.902z"
            />
            <path stroke="#49565D" strokeWidth=".75" d="M13.56 9L18 9M0 9L9.757 9" />
            <path
                fill="#B3B3B3"
                d="M9.757 9c0-1.05.852-1.902 1.902-1.902 1.05 0 1.902.851 1.902 1.902 0 1.05-.852 1.901-1.902 1.901-1.05 0-1.902-.85-1.902-1.9"
            />
            <path
                stroke="#49565D"
                strokeLinecap="round"
                strokeWidth=".75"
                d="M9.757 9c0-1.05.852-1.902 1.902-1.902 1.05 0 1.902.851 1.902 1.902 0 1.05-.852 1.901-1.902 1.901-1.05 0-1.902-.85-1.902-1.9z"
            />
        </g>
    </svg>
);

const CheckMarkSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="10" height="10" viewBox="0 0 10 10">
        <path
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="2"
            d="M8 7L2.881 14 0 11.176"
            transform="translate(1 -6)"
        />
    </svg>
);

const ArrowOutlinedSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 10 6"
        className={styles.animation}
    >
        <path
            fill="inherit"
            d="M1.372.665l3.33 3.7c.152.169.369.191.539.066l.07-.063L8.632.763l.736.678-3.322 3.604c-.542.59-1.41.618-1.983.094l-.104-.105-3.33-3.7.743-.669z"
        />
    </svg>
);

const NoResultsSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="151" height="64" viewBox="0 0 151 64">
        <g fill="none" fillRule="evenodd" stroke="#D0D0D0" strokeWidth="2">
            <path
                d="M139.42 18.513H34.61c-1.825 0-3.478.74-4.674 1.936C28.74 21.645 28 23.298 28 25.123c0 .944.197 1.842.554 2.654H13.897c-3.561 0-6.786 1.444-9.12 3.778C2.444 33.889 1 37.113 1 40.675c0 3.56 1.444 6.785 3.777 9.119 2.34 2.339 5.572 3.784 9.143 3.777l8.146.38c-.306 2.197.47 4.224 1.87 5.626 1.196 1.196 2.849 1.936 4.674 1.936h49.78c1.836 0 3.498-.75 4.693-1.999 1.387-1.448 2.141-3.562 1.847-5.943h25.173c3.561 0 6.786-1.443 9.12-3.777 2.55-2.55 4.037-6.164 3.74-10.12h16.456c2.922 0 5.567-1.184 7.482-3.099 1.915-1.914 3.099-4.56 3.099-7.481 0-2.922-1.184-5.568-3.1-7.482-1.914-1.915-4.56-3.1-7.48-3.1z"
                transform="translate(0 1)"
            />
            <path
                strokeLinecap="round"
                d="M99.309 37.992L99.309 7.247M80.835 37.992L80.835.286M99.309 21.611L105.66 10.158M80.922 14.661L85.454 6.739"
                transform="translate(0 1)"
            />
            <path
                d="M51.5 31.513c6.351 0 11.5 5.148 11.5 11.5 0 .214-.006.427-.017.638H40.017c-.011-.211-.017-.424-.017-.638 0-6.352 5.149-11.5 11.5-11.5z"
                transform="translate(0 1)"
            />
        </g>
    </svg>
);
const ClearSelectionSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="20"
        height="20"
        viewBox="0 0 20 20"
    >
        <defs>
            <path id="prefix__a" d="M0 0L20 0 20 20 0 20z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <mask id="prefix__b" fill="#fff">
                <use xlinkHref="#prefix__a" />
            </mask>
            <path
                fill="#F2F2F2"
                d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10C0 4.478 4.477 0 10 0s10 4.478 10 10"
                mask="url(#prefix__b)"
            />
            <g stroke="#5E63E5" strokeLinecap="round" strokeWidth="1.5">
                <path d="M6.25 6.25L0 0M0 6.25L6.25 0" transform="translate(6.875 6.875)" />
            </g>
        </g>
    </svg>
);

const DuplicateIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="16" height="19" viewBox="0 0 16 19">
        <g fill="none" fillRule="evenodd">
            <path
                fill="#49565D"
                d="M11 0c.552 0 1 .448 1 1v2h-.75V1c0-.138-.112-.25-.25-.25H1C.862.75.75.862.75 1v12c0 .138.112.25.25.25h2V14H1c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1h10zm1 3.75V13c0 .552-.448 1-1 1H3.75v-.75H11c.138 0 .25-.112.25-.25V3.75H12z"
            />
            <path
                fill="#49565D"
                d="M15 3c.552 0 1 .448 1 1v14c0 .552-.448 1-1 1H4c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h11zM3.75 4v14c0 .138.112.25.25.25h11c.138 0 .25-.112.25-.25V4c0-.138-.112-.25-.25-.25H4c-.138 0-.25.112-.25.25z"
            />
            <path
                fill="#D0D0D0"
                d="M15.25 4v14c0 .138-.112.25-.25.25H4c-.138 0-.25-.112-.25-.25V4c0-.138.112-.25.25-.25h11c.138 0 .25.112.25.25z"
            />
            <path
                fill="#49565D"
                d="M6 8.875L8 8.875 8 8.125 6 8.125z"
                transform="matrix(-1 0 0 1 14 0)"
            />
            <path
                fill="#49565D"
                d="M3 14L9.243 14 9.243 13.25 3 13.25z"
                transform="matrix(-1 0 0 1 12.243 0)"
            />
            <path
                fill="#49565D"
                d="M9 8.875L14 8.875 14 8.125 9 8.125z"
                transform="matrix(-1 0 0 1 23 0)"
            />
            <path
                fill="#49565D"
                d="M5 6.875L14 6.875 14 6.125 5 6.125z"
                transform="matrix(-1 0 0 1 19 0)"
            />
            <path
                stroke="#49565D"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth=".75"
                d="M9.621 15.742L7.5 13.621 9.621 11.5"
                transform="matrix(-1 0 0 1 17.121 0)"
            />
        </g>
    </svg>
);

const AlertIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 24 24"
        stroke={props.fill}
        className={styles.animation}
    >
        <g fillRule="evenodd">
            <circle cx="12" cy="12" r="11.25" stroke="inherit" fill="none" strokeWidth="1.5" />
            <circle cx="12" cy="17.5" r="1.5" fill="inherit" stroke="none" />
            <path
                fill="none"
                stroke="inherit"
                strokeLinecap="round"
                strokeWidth="2.5"
                d="M12 13L12 6"
            />
        </g>
    </svg>
);

const AlertColoredIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="16" height="16" viewBox="0 0 16 16">
        <g fill="none" fillRule="evenodd">
            <g transform="translate(-447 -435) translate(0 111) translate(447 324)">
                <circle cx="8" cy="8" r="7.5" fill="transparent" stroke="#FFF" />
                <g fillRule="nonzero">
                    <path
                        fill="#FFF"
                        d="M1.709 5.905L2 0H.023l.291 5.905H1.71zM1.006 9c.312 0 .556-.092.731-.275.175-.183.263-.434.263-.753 0-.33-.087-.584-.26-.761-.173-.177-.418-.266-.734-.266-.328 0-.577.087-.749.26-.171.173-.257.429-.257.767 0 .327.088.58.263.759.175.18.423.269.743.269z"
                        transform="translate(7 3.5)"
                    />
                </g>
            </g>
        </g>
    </svg>
);

const RecentIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="16" height="16" viewBox="0 0 16 16">
        <g fill="none" fillRule="evenodd">
            <path
                fill="#49565D"
                d="M8 0C3.582 0 0 3.582 0 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8m0 .75c3.998 0 7.25 3.252 7.25 7.25S11.998 15.25 8 15.25.75 11.998.75 8 4.002.75 8 .75"
            />
            <path
                stroke="#676DFD"
                strokeLinecap="round"
                strokeWidth=".75"
                d="M7.5 3.5L7.5 8.5M7.5 8.5L10.5 8.5"
            />
        </g>
    </svg>
);

const VarianceIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
        viewBox="0 0 18 18"
        className={styles.animation}
    >
        <defs>
            <path id="a" d="M0 0h3.5v8H0z" />
        </defs>
        <g fill="inherit" fillRule="evenodd">
            <path stroke="#49565D" strokeWidth=".75" d="M1.5 6.5l5.083-4.141L11.5 5.5l5-4" />
            <path fill="inherit" d="M.375 10.408l.031 7.217h2.686l.032-.031-.032-7.218z" />
            <g transform="translate(0 10)">
                <mask id="b" fill="#fff">
                    <use xlinkHref="#a" />
                </mask>
                <path
                    fill="#49565D"
                    d="M3.093 0H.407A.408.408 0 000 .407v7.186C0 7.817.183 8 .407 8h2.686a.407.407 0 00.407-.407V.407A.407.407 0 003.093 0zM.75 7.25h2V.75h-2v6.5z"
                    mask="url(#b)"
                />
            </g>
            <path
                fill="inherit"
                d="M5.288 17.625a.08.08 0 01-.08-.08v-9.09a.08.08 0 01.08-.08h2.59a.08.08 0 01.08.08v9.09a.08.08 0 01-.08.08h-2.59z"
            />
            <path
                fill="#49565D"
                d="M7.878 8h-2.59a.455.455 0 00-.455.455v9.09c0 .251.204.455.455.455h2.59a.455.455 0 00.455-.455v-9.09A.455.455 0 007.878 8zm-2.295 9.25h2v-8.5h-2v8.5z"
            />
            <path fill="inherit" d="M10.048 17.625l-.006-6.244 2.744-.006.006 6.244-.006.006z" />
            <path
                fill="#49565D"
                d="M12.786 11h-2.738a.38.38 0 00-.38.381v6.238c0 .21.17.381.38.381h2.738c.21 0 .381-.171.381-.381v-6.238a.38.38 0 00-.38-.381zm-2.369 6.25h2v-5.5h-2v5.5z"
            />
            <path
                fill="inherit"
                d="M14.998 17.625a.124.124 0 01-.123-.123V6.498c0-.067.056-.123.123-.123h2.504c.067 0 .123.056.123.123v11.004a.124.124 0 01-.123.123h-2.504z"
            />
            <path
                fill="#49565D"
                d="M17.502 6h-2.504a.5.5 0 00-.498.498v11.004a.5.5 0 00.498.498h2.504a.5.5 0 00.498-.498V6.498A.5.5 0 0017.502 6zM15.25 17.25h2V6.75h-2v10.5z"
            />
            <path
                fill="#FFF"
                d="M16.5 2.625c-.62 0-1.125-.505-1.125-1.125S15.88.375 16.5.375 17.625.88 17.625 1.5 17.12 2.625 16.5 2.625"
            />
            <path
                fill="#49565D"
                d="M16.5 0a1.5 1.5 0 10.001 3.001A1.5 1.5 0 0016.5 0m0 .75c.413 0 .75.337.75.75s-.337.75-.75.75-.75-.337-.75-.75.337-.75.75-.75"
            />
            <path
                fill="#FFF"
                d="M11.5 6.625c-.62 0-1.125-.505-1.125-1.125s.505-1.125 1.125-1.125 1.125.505 1.125 1.125-.505 1.125-1.125 1.125"
            />
            <path
                fill="#49565D"
                d="M11.5 4a1.5 1.5 0 10.001 3.001A1.5 1.5 0 0011.5 4m0 .75c.413 0 .75.337.75.75s-.337.75-.75.75-.75-.337-.75-.75.337-.75.75-.75"
            />
            <path
                fill="#FFF"
                d="M6.5 3.625c-.62 0-1.125-.505-1.125-1.125S5.88 1.375 6.5 1.375 7.625 1.88 7.625 2.5 7.12 3.625 6.5 3.625"
            />
            <path
                fill="#49565D"
                d="M6.5 1a1.5 1.5 0 10.001 3.001A1.5 1.5 0 006.5 1m0 .75c.413 0 .75.337.75.75s-.337.75-.75.75-.75-.337-.75-.75.337-.75.75-.75"
            />
            <path
                fill="#FFF"
                d="M1.5 7.625C.88 7.625.375 7.12.375 6.5S.88 5.375 1.5 5.375 2.625 5.88 2.625 6.5 2.12 7.625 1.5 7.625"
            />
            <path
                fill="#49565D"
                d="M1.5 5a1.5 1.5 0 10.001 3.001A1.5 1.5 0 001.5 5m0 .75c.413 0 .75.337.75.75s-.337.75-.75.75-.75-.337-.75-.75.337-.75.75-.75"
            />
        </g>
    </svg>
);

const ReportsIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 18 18"
        className={styles.animation}
    >
        <g fill="inherit" fillRule="evenodd" stroke="#49565D">
            <rect
                width="17.25"
                height="14.25"
                x=".375"
                y=".375"
                strokeWidth=".75"
                rx="1"
                fill="none"
            />
            <path strokeLinejoin="round" strokeWidth=".75" d="M4 17.5h10" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 15v2" />
            <path
                d="M4 9h2v3H4zm4-3h2v6H8zm4-3h2v9h-2z"
                fill="inherit"
                strokeLinejoin="round"
                strokeWidth=".75"
            />
        </g>
    </svg>
);

const VisitsIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 18 18"
        className={styles.animation}
    >
        <g fill="inherit" fillRule="evenodd" stroke="#49565D" strokeWidth=".75">
            <path
                fill="none"
                d="M13.313 10.82L10.485 13.65 13.313 16.479M10.484 13.65L17.916 13.65M14.587 7.886L17.416 5.056 14.587 2.227M17.416 5.056L9.984 5.056"
            />
            <path
                fill="inherit"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.254 12.858v-2.45c0-1.104-.895-2-2-2h-2.88c-1.103 0-2 .896-2 2v2.45l2.87 4.767h1.152l2.858-4.767z"
            />
            <path
                fill="none"
                d="M1.08 2.375h5.47v2.377c0 1.459-1.194 2.653-2.654 2.653h-.164c-1.459 0-2.653-1.194-2.653-2.653V2.375z"
            />
            <path
                fill="none"
                strokeLinecap="round"
                d="M2.941 5.192c.135.353.474.604.873.604.4 0 .738-.251.873-.604"
            />
            <path
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.063 15.531L2.063 11.32M5.567 15.531L5.567 11.32"
            />
            <path fill="none" d="M6.55.375H2.417c-.74 0-1.338.599-1.338 1.337v.663h5.47v-2z" />
        </g>
    </svg>
);

const FlowIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 18 18"
        className={styles.animation}
    >
        <g fill="inherit" fillRule="evenodd">
            <path
                fill="#49565D"
                d="M2 7.013c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2m0 .75c.689 0 1.25.561 1.25 1.25 0 .69-.561 1.25-1.25 1.25S.75 9.703.75 9.013c0-.689.561-1.25 1.25-1.25M16 7.013c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2m0 .75c.689 0 1.25.561 1.25 1.25 0 .69-.561 1.25-1.25 1.25s-1.25-.56-1.25-1.25c0-.689.561-1.25 1.25-1.25M2 0C.896 0 0 .895 0 2c0 1.104.896 2 2 2s2-.896 2-2c0-1.105-.896-2-2-2m0 .75c.689 0 1.25.561 1.25 1.25 0 .69-.561 1.25-1.25 1.25S.75 2.69.75 2C.75 1.311 1.311.75 2 .75M16 0c-1.104 0-2 .895-2 2 0 1.104.896 2 2 2s2-.896 2-2c0-1.105-.896-2-2-2m0 .75c.689 0 1.25.561 1.25 1.25 0 .69-.561 1.25-1.25 1.25S14.75 2.69 14.75 2c0-.689.561-1.25 1.25-1.25M16 14c-1.104 0-2 .895-2 2 0 1.104.896 2 2 2s2-.896 2-2c0-1.105-.896-2-2-2m0 .75c.689 0 1.25.561 1.25 1.25 0 .69-.561 1.25-1.25 1.25s-1.25-.56-1.25-1.25c0-.689.561-1.25 1.25-1.25M2 14c-1.104 0-2 .895-2 2 0 1.104.896 2 2 2s2-.896 2-2c0-1.105-.896-2-2-2m0 .75c.689 0 1.25.561 1.25 1.25 0 .69-.561 1.25-1.25 1.25S.75 16.69.75 16c0-.689.561-1.25 1.25-1.25"
            />
            <path
                fill="none"
                stroke="#49565D"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth=".75"
                d="M4 9.013L14 9.013M9 8.675c0-3.1-2.145-5.716-5.021-6.458M14.021 2.217c-2.877.742-5.02 3.358-5.02 6.458M14.021 15.783c-2.877-.741-5.02-3.358-5.02-6.458M3.978 15.783C6.855 15.042 9 12.425 9 9.325"
            />
            <path
                fill="inherit"
                d="M9 11.638c-1.447 0-2.625-1.178-2.625-2.625S7.553 6.388 9 6.388s2.625 1.178 2.625 2.625S10.447 11.638 9 11.638"
            />
            <path
                fill="#49565D"
                d="M9 6.013c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3m0 .75c1.24 0 2.25 1.01 2.25 2.25 0 1.241-1.01 2.25-2.25 2.25s-2.25-1.009-2.25-2.25c0-1.24 1.01-2.25 2.25-2.25"
            />
        </g>
    </svg>
);

const TradeAreaIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 18 18"
        className={styles.animation}
    >
        <g fill="inherit" fillRule="evenodd">
            <path
                fill="inherit"
                d="M12 5H6c-.552 0-1 .447-1 1v6c0 .553.448 1 1 1h6c.552 0 1-.447 1-1V6c0-.553-.448-1-1-1"
            />
            <path
                fill="#49565D"
                d="M12 5H1c-.552 0-1 .447-1 1v11c0 .553.448 1 1 1h11c.552 0 1-.447 1-1V6c0-.553-.448-1-1-1m0 .75c.138 0 .25.112.25.25v11c0 .138-.112.25-.25.25H1c-.138 0-.25-.112-.25-.25V6c0-.138.112-.25.25-.25h11"
            />
            <path
                fill="#49565D"
                d="M17 0H6c-.552 0-1 .447-1 1v11c0 .553.448 1 1 1h11c.552 0 1-.447 1-1V1c0-.553-.448-1-1-1m0 .75c.138 0 .25.112.25.25v11c0 .138-.112.25-.25.25H6c-.138 0-.25-.112-.25-.25V1c0-.138.112-.25.25-.25h11"
            />
        </g>
    </svg>
);

const RankingIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 18 18"
        className={styles.animation}
    >
        <g fill="inherit" fillRule="evenodd">
            <path
                fill="inherit"
                d="M6.653 17.625c-.153 0-.278-.124-.278-.277V6.652c0-.153.125-.277.278-.277h4.694c.154 0 .278.124.278.277v10.696c0 .153-.124.277-.278.277H6.653z"
            />
            <path
                fill="#49565D"
                d="M11.347 6H6.653C6.293 6 6 6.292 6 6.652v10.696c0 .36.292.652.653.652h4.694c.361 0 .653-.292.653-.652V6.652c0-.36-.292-.652-.653-.652zM6.75 17.25h4.5V6.75h-4.5v10.5zM3.5 4H1v.75h2.25v1.375H1.5c-.276 0-.5.224-.5.5V8.5c0 .276.224.5.5.5H4v-.75H1.75V6.875H3.5c.276 0 .5-.224.5-.5V4.5c0-.276-.224-.5-.5-.5M9.5 0H8v.75h1.25V5H10V.5c0-.276-.224-.5-.5-.5M16.5 6H14v.75h2.25v1.375H14v.75h2.25v1.375H14V11h2.5c.276 0 .5-.224.5-.5v-4c0-.276-.224-.5-.5-.5"
            />
            <path
                fill="#49565D"
                d="M.75 17.25v-6.5h5.929V10H.516c-.285 0-.516.231-.516.516v6.968c0 .285.231.516.516.516h6.163v-.75H.75zM17.579 12H11.32v.75h5.929v4.5h-5.93V18h6.259c.233 0 .42-.188.42-.421v-5.158c0-.233-.187-.421-.42-.421"
            />
        </g>
    </svg>
);

const LoyaltyIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 18 18"
        className={styles.animation}
    >
        <g fill="inherit" fillRule="evenodd">
            <path
                fill="#49565D"
                d="M17 0H1C.448 0 0 .448 0 1v16c0 .552.448 1 1 1h16c.552 0 1-.448 1-1V1c0-.552-.448-1-1-1m0 .75c.138 0 .25.112.25.25v16c0 .138-.112.25-.25.25H1c-.138 0-.25-.112-.25-.25V1C.75.862.862.75 1 .75h16"
            />
            <path
                fill="inherit"
                d="M8.449 13.017c.31.29.792.29 1.103 0 .618-.574 1.627-1.51 2.34-2.174 1.096-1.019 2.029-1.979 2.029-3.52 0-1.23-.77-2.557-2.457-2.557-.872 0-1.302.434-1.757.893-.151.152-.396.391-.554.545-.086.083-.22.083-.306 0-.158-.154-.403-.393-.554-.545-.455-.459-.885-.893-1.756-.893-1.69 0-2.458 1.326-2.458 2.557 0 1.541.933 2.501 2.029 3.52l2.34 2.174"
            />
            <path
                fill="none"
                stroke="#49565D"
                strokeLinecap="round"
                strokeWidth=".75"
                d="M8.449 13.017c.31.29.792.29 1.103 0 .618-.574 1.627-1.51 2.34-2.174 1.096-1.019 2.029-1.979 2.029-3.52 0-1.23-.77-2.557-2.457-2.557-.872 0-1.302.434-1.757.893-.151.152-.396.391-.554.545-.086.083-.22.083-.306 0-.158-.154-.403-.393-.554-.545-.455-.459-.885-.893-1.756-.893-1.69 0-2.458 1.326-2.458 2.557 0 1.541.933 2.501 2.029 3.52l2.34 2.174z"
            />
        </g>
    </svg>
);

const RegularArrowIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <line x1="4" y1="12" x2="20" y2="12" />
        <polyline points="14 6 20 12 14 18" />
    </svg>
);

const DriveTimeIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        {...props}
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>Icons_18/Drive_Time</title>
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Artboard-1" transform="translate(-433.000000, -2228.000000)" strokeWidth="0.75">
                <g id="Group" transform="translate(433.000000, 2228.000000)">
                    <circle
                        id="Oval-Copy-18"
                        stroke="#49565D"
                        cx="5.5"
                        cy="15.5"
                        r="2.125"
                    ></circle>
                    <circle
                        id="Oval-Copy-19"
                        stroke="#49565D"
                        cx="13.5"
                        cy="15.5"
                        r="2.125"
                    ></circle>
                    <path
                        d="M2.32486572,16 L0.9,16 C0.623857625,16 0.4,15.7761424 0.4,15.5 L0.4,13.5 C0.4,12.1192881 1.51928813,11 2.9,11 L17.5524902,11 L17.5524902,11"
                        id="Rectangle-Copy-38"
                        stroke="#49565D"
                        strokeLinecap="round"
                        transform="translate(8.976245, 13.500000) scale(-1, 1) translate(-8.976245, -13.500000) "
                    ></path>
                    <line
                        x1="7.5"
                        y1="16"
                        x2="11.362915"
                        y2="16"
                        id="Line-4-Copy-4"
                        stroke="#49565D"
                    ></line>
                    <line
                        x1="0.5"
                        y1="12.7"
                        x2="2.87792969"
                        y2="12.7"
                        id="Stroke-5-Copy-17"
                        stroke="#49565D"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="16"
                        y1="12.5"
                        x2="17.1506348"
                        y2="12.5"
                        id="Stroke-5-Copy-18"
                        stroke="#49565D"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="0.5"
                        y1="14.3"
                        x2="1.87451172"
                        y2="14.3"
                        id="Stroke-5-Copy-19"
                        stroke="#49565D"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="0.4"
                        y1="16"
                        x2="3.24902344"
                        y2="16"
                        id="Stroke-5-Copy-20"
                        stroke="#49565D"
                        strokeLinecap="round"
                    ></line>
                    <polyline
                        id="Rectangle-Copy-39"
                        stroke="#49565D"
                        transform="translate(6.000000, 8.000000) scale(-1, 1) translate(-6.000000, -8.000000) "
                        points="4.48721313 5 8 5 10 11 2 11"
                    ></polyline>
                    <g transform="translate(8.000000, 0.000000)">
                        <circle
                            id="Oval-Copy-20"
                            stroke="#49565D"
                            fill="#676DFD"
                            cx="5"
                            cy="5"
                            r="4.625"
                        ></circle>
                        <line
                            x1="5"
                            y1="2.40625"
                            x2="5"
                            y2="5.5"
                            id="Stroke-3-Copy-6"
                            stroke="#FFFFFF"
                            strokeLinecap="round"
                        ></line>
                        <line
                            x1="5"
                            y1="5.5"
                            x2="7.36895752"
                            y2="5.5"
                            id="Stroke-5-Copy-21"
                            stroke="#FFFFFF"
                            strokeLinecap="round"
                        ></line>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const LineGraphIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
    >
        <path
            d="M16 7L12.9558 11.5662C12.5299 12.2051 11.5728 12.1455 11.2294 11.4587L7.74278 4.48556C7.40577 3.81154 6.47263 3.73832 6.03462 4.35153L2 10"
            stroke="#49565D"
            strokeWidth="0.75"
            strokeLinecap="round"
        />
        <circle cx="12" cy="13" r="1.625" fill="#D0D0D0" stroke="#49565D" strokeWidth="0.75" />
        <circle cx="16" cy="7" r="1.625" fill="white" stroke="#49565D" strokeWidth="0.75" />
        <circle cx="7" cy="3" r="2.625" fill="#D0D0D0" stroke="#49565D" strokeWidth="0.75" />
        <circle cx="2" cy="10" r="1.625" fill="white" stroke="#49565D" strokeWidth="0.75" />
        <path d="M0.5 17.5H17.5" stroke="#49565D" strokeWidth="0.75" strokeLinecap="round" />
    </svg>
);

const PlusIconCreateSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
            <g>
                <g transform="translate(-1197 -20) translate(1197 20)">
                    <circle cx="10" cy="10" r="9.625" stroke="#49565D" strokeWidth=".75" />
                    <g stroke="#676DFD" strokeLinecap="round" strokeWidth="1.002">
                        <path d="M0 4L8 4M4 0L4 8" transform="translate(6 6)" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const PlusIconCreateActiveSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
            <circle cx="10" cy="10" r="10" fill="#676DFD" />
            <g stroke="#FFF" strokeLinecap="round" strokeWidth="1.002">
                <path d="M0 4L8 4M4 0L4 8" transform="translate(6 6)" />
            </g>
        </g>
    </svg>
);

const CreatePoiSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="18" height="18" viewBox="0 0 18 18">
        <g fill="none" fillRule="evenodd" stroke="#49565D" strokeWidth=".75">
            <path fill="#5E63E5" d="M2.7 2.7L2.7 15.3 15.3 15.3 15.3 2.7z" />
            <circle cx="3.15" cy="3.15" r="2.775" fill="#FFF" />
            <circle cx="14.85" cy="3.15" r="2.775" fill="#FFF" />
            <circle cx="3.15" cy="14.85" r="2.775" fill="#FFF" />
            <circle cx="14.85" cy="14.85" r="2.775" fill="#FFF" />
        </g>
    </svg>
);

const CustomVenueSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="16" height="16" viewBox="0 0 16 16">
        <title>Custom POI</title>
        <g fill="none" fillRule="evenodd">
            <path fill="#FFF" d="M1.375 15.625L14.625 15.625 14.625 0.375 1.375 0.375z" />
            <path fill="#49565D" d="M1 16h14V0H1v16zm.75-.75h12.5V.75H1.75v14.5z" />
            <path
                fill="#FFF"
                d="M4.375 15.625V9.5c0-.069.056-.125.125-.125h3c.069 0 .125.056.125.125v6.125h-3.25z"
            />
            <path
                fill="#49565D"
                d="M7.5 9h-3c-.276 0-.5.224-.5.5V16h4V9.5c0-.276-.224-.5-.5-.5zm-2.75 6.25h2.5v-5.5h-2.5v5.5z"
            />
            <path
                stroke="#49565D"
                strokeLinecap="round"
                strokeWidth=".75"
                d="M12.5 11.5L9.5 11.5"
            />
            <path
                fill="#d0d0d0"
                d="M3 6.625C1.553 6.625.375 5.447.375 4V.375h5.25V4c0 1.447-1.178 2.625-2.625 2.625"
            />
            <path
                fill="#49565D"
                d="M6 0H0v4c0 1.657 1.343 3 3 3s3-1.343 3-3V0zm-.75.75V4c0 1.24-1.01 2.25-2.25 2.25S.75 5.24.75 4V.75h4.5z"
            />
            <path
                fill="#d0d0d0"
                d="M8 6.625C6.553 6.625 5.375 5.447 5.375 4V.375h5.25V4c0 1.447-1.178 2.625-2.625 2.625"
            />
            <path
                fill="#49565D"
                d="M11 0H5v4c0 1.657 1.343 3 3 3s3-1.343 3-3V0zm-.75.75V4c0 1.24-1.01 2.25-2.25 2.25S5.75 5.24 5.75 4V.75h4.5z"
            />
            <path
                fill="#d0d0d0"
                d="M13 6.625c-1.447 0-2.625-1.178-2.625-2.625V.375h5.25V4c0 1.447-1.178 2.625-2.625 2.625"
            />
            <path
                fill="#49565D"
                d="M16 0h-6v4c0 1.657 1.343 3 3 3s3-1.343 3-3V0zm-.75.75V4c0 1.24-1.01 2.25-2.25 2.25S10.75 5.24 10.75 4V.75h4.5z"
            />
            <path stroke="#49565D" strokeLinecap="round" strokeWidth=".75" d="M12.5 9.5L9.5 9.5" />
        </g>
    </svg>
);

const StarIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="18" height="18" viewBox="0 0 18 18">
        <g>
            <g fill="inherit" stroke="#49565D" strokeWidth=".75">
                <g>
                    <g>
                        <g>
                            <path
                                d="M14.292 16c-.065 0-.13-.013-.19-.04L9 13.67 3.9 15.96c-.06.027-.126.04-.19.04-.091 0-.181-.027-.258-.078-.13-.089-.198-.237-.177-.386l.76-5.23L.76 6.49c-.111-.109-.15-.265-.1-.408.05-.143.182-.25.34-.277l4.931-.942L8.614.215C8.69.083 8.839 0 9 0s.31.083.386.215l2.684 4.648 4.93.942c.159.027.29.134.34.277.05.143.011.3-.1.408l-3.274 3.816.76 5.23c.02.15-.046.297-.177.386-.076.051-.166.078-.257.078z"
                                transform="translate(-1202 -435) translate(1192 425) translate(10 10) translate(0 1)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const StarOutlineIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="20" height="20" viewBox="0 0 20 20">
        <g>
            <g stroke="#49565D" strokeWidth=".75">
                <g>
                    <g>
                        <g>
                            <g
                                fill="#FFF"
                                transform="translate(-1261 -192) translate(1030 45) translate(46 146) translate(185 1)"
                            >
                                <rect width="19.25" height="19.25" x=".375" y=".375" rx="2" />
                            </g>
                            <path
                                fill="inherit"
                                d="M12.94 14c-.036 0-.072-.008-.106-.023L10 12.69l-2.834 1.288c-.034.015-.07.023-.106.023-.05 0-.1-.015-.143-.044-.072-.05-.11-.133-.098-.217l.422-2.942L5.068 8.65c-.062-.061-.084-.15-.056-.23.028-.08.1-.14.188-.155l3.095-.53 1.49-2.615C9.828 5.046 9.91 5 10 5s.172.046.215.12l1.49 2.616 3.095.53c.088.015.16.074.188.155.028.08.006.169-.056.23l-2.173 2.146.422 2.942c.012.084-.025.167-.098.217-.042.029-.093.044-.143.044z"
                                transform="translate(-1261 -192) translate(1030 45) translate(46 146) translate(185 1)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const EditIconCopySvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="17" height="18" viewBox="0 0 17 18">
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g>
                            <path
                                stroke="#49565D"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth=".75"
                                d="M5.325 14.492L0 15.885 1.393 10.56"
                                transform="translate(-1139 -478) translate(1127 422) translate(12 56) translate(.74 .375)"
                            />
                            <path
                                stroke="#49565D"
                                strokeLinecap="round"
                                strokeWidth=".75"
                                d="M10.103 1.85L11.66.293c.391-.39 1.024-.39 1.414 0l2.518 2.517c.39.391.39 1.024 0 1.415l-1.557 1.557"
                                transform="translate(-1139 -478) translate(1127 422) translate(12 56) translate(.74 .375)"
                            />
                            <path
                                fill="currentColor"
                                d="M5.325 14.492L1.393 10.56 10.195 1.759 14.126 5.691z"
                                transform="translate(-1139 -478) translate(1127 422) translate(12 56) translate(.74 .375)"
                            />
                            <path
                                stroke="#49565D"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth=".75"
                                d="M5.325 14.492L1.393 10.56 10.195 1.759 14.126 5.691z"
                                transform="translate(-1139 -478) translate(1127 422) translate(12 56) translate(.74 .375)"
                            />
                            <path
                                stroke="#49565D"
                                strokeWidth=".75"
                                d="M7.97 7.916L5.301 10.585"
                                transform="translate(-1139 -478) translate(1127 422) translate(12 56) translate(.74 .375)"
                            />
                        </g>
                        <path
                            stroke="#49565D"
                            strokeWidth=".75"
                            d="M17 17.5L0 17.5"
                            transform="translate(-1139 -478) translate(1127 422) translate(12 56)"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const PopupIllustrationsDeleteSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        width="100"
        height="100"
        viewBox="0 0 100 100"
    >
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <path
                            fill="#E7E7F6"
                            d="M100 50c0 27.614-22.386 50-50 50S0 77.614 0 50 22.386 0 50 0s50 22.386 50 50"
                            transform="translate(-650 -250) translate(475 200) translate(175 50)"
                        />
                        <g>
                            <path
                                fill="#676DFD"
                                d="M36.87 49.623c3.015 0 5.462-2.452 5.462-5.474V15.307c-1.807-.652-4.31.024-7.51 2.026C30.02 20.337 29.33 23.335 23.213 24c-6.116.665-8.29-3-12.933-4-3.096-.667-5.157-.009-6.184 1.974v22.175c0 3.022 2.447 5.474 5.462 5.474"
                                transform="translate(-650 -250) translate(475 200) translate(175 50) translate(27 25)"
                            />
                            <path
                                stroke="#49565D"
                                strokeLinecap="round"
                                strokeWidth="2"
                                d="M36.87 49.623c3.015 0 5.462-2.452 5.462-5.474V11.307H4.097v32.842c0 3.022 2.447 5.474 5.462 5.474h27.31z"
                                transform="translate(-650 -250) translate(475 200) translate(175 50) translate(27 25)"
                            />
                            <path
                                stroke="#49565D"
                                strokeWidth="2"
                                d="M46.429 5.833L0 5.833M46.429 11.307L0 11.307"
                                transform="translate(-650 -250) translate(475 200) translate(175 50) translate(27 25)"
                            />
                            <path
                                stroke="#FFF"
                                strokeLinecap="round"
                                strokeWidth="2"
                                d="M23.214 34.149L23.214 42.781M15.021 42.781L15.021 28.36M31.408 42.781L31.408 28.36"
                                transform="translate(-650 -250) translate(475 200) translate(175 50) translate(27 25)"
                            />
                            <path
                                stroke="#49565D"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M15.021 5.833h16.387v-4.14c0-.736-.597-1.333-1.334-1.333h-13.72c-.736 0-1.333.597-1.333 1.333v4.14h0z"
                                transform="translate(-650 -250) translate(475 200) translate(175 50) translate(27 25)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const FixedDiagramSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="18" height="18" viewBox="0 0 18 18">
        <g fill="none" fillRule="evenodd">
            <g transform="translate(0 3)">
                <circle cx="12" cy="6" r="5.625" stroke="#49565D" strokeWidth=".75" />
                <circle cx="6" cy="6" r="5.625" stroke="#49565D" strokeWidth=".75" />
                <path
                    fill="#D0D0D0"
                    stroke="#49565D"
                    strokeWidth=".75"
                    d="M9.001.803C10.794 1.841 12 3.78 12 6s-1.206 4.16-2.999 5.197C7.207 10.16 6 8.22 6 6 6 3.816 7.167 1.904 8.911.855z"
                />
            </g>
        </g>
    </svg>
);

const ProportionalDiagramSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        stroke="#49565D"
    >
        <g fill="none" fillRule="evenodd">
            <g stroke="inherit" strokeWidth=".75">
                <g>
                    <circle cx="8" cy="10" r="7.625" />
                    <circle cx="13.5" cy="4.5" r="4.125" />
                    <path
                        fill="#D0D0D0"
                        d="M9.838 2.6c1.367.337 2.59 1.044 3.554 2.009.964.964 1.672 2.186 2.01 3.553-.57.296-1.216.463-1.902.463-1.14 0-2.17-.462-2.917-1.208C9.837 6.67 9.375 5.639 9.375 4.5c0-.685.167-1.332.463-1.9z"
                    />
                </g>
            </g>
        </g>
    </svg>
);

const ChevronIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="7" height="11" viewBox="0 0 7 11">
        <g
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            stroke="currentColor"
            strokeWidth="2"
        >
            <path
                d="M4.5 0.5L0.5 4.5"
                transform="translate(-261 -242) translate(230 140) translate(32 97) rotate(-180 2.5 7.5) matrix(-1 0 0 1 5 0)"
            />
            <path
                d="M4.5 4.5L0.5 8.5"
                transform="translate(-261 -242) translate(230 140) translate(32 97) rotate(-180 2.5 7.5) matrix(-1 0 0 1 5 0) matrix(1 0 0 -1 0 13)"
            />
        </g>
    </svg>
);

const ChevronCircleIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="18" height="18" viewBox="0 0 18 18">
        <g fill="none" fillRule="evenodd">
            <g>
                <g transform="translate(-578 -1217) matrix(-1 0 0 1 596 1217)">
                    <circle cx="9" cy="9" r="9" fill="#49565D" />
                    <g stroke="#FFF" strokeLinecap="round">
                        <path d="M4.5 0.5L0.5 4.5" transform="matrix(-1 0 0 1 12 4.5)" />
                        <path
                            d="M4.5 4.5L0.5 8.5"
                            transform="matrix(-1 0 0 1 12 4.5) matrix(1 0 0 -1 0 13)"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const AlreadyPurchasedIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="18" height="18" viewBox="0 0 18 18">
        <g fill="none" fillRule="evenodd">
            <g strokeWidth=".75">
                <g>
                    <g>
                        <path
                            stroke="#49565D"
                            strokeLinecap="round"
                            d="M14.375 13.358v-9h-14v11c0 1.104.896 2 2 2h9"
                            transform="translate(-1151 -424) translate(225 140) translate(926 284)"
                        />
                        <path
                            stroke="#49565D"
                            strokeLinecap="round"
                            d="M4.9 7.358V3.055c0-1.326.949-2.55 2.269-2.67C8.651.253 9.9 1.422 9.9 2.876v2.483"
                            transform="translate(-1151 -424) translate(225 140) translate(926 284)"
                        />
                        <g
                            fill="#676DFD"
                            stroke="#49565D"
                            transform="translate(-1151 -424) translate(225 140) translate(926 284) translate(6.875 6.858)"
                        >
                            <circle cx="5.5" cy="5.5" r="5.125" />
                        </g>
                        <path
                            stroke="#FFF"
                            strokeLinecap="round"
                            d="M15.07 10.8L11.639 14.23 10 12.591"
                            transform="translate(-1151 -424) translate(225 140) translate(926 284)"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const NotificationIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <path
                            stroke="#49565D"
                            strokeWidth=".75"
                            d="M10.625.375v1.8l-2.815.402L7.443.375h3.182zM12 16.5c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3z"
                            transform="translate(-1298 -20) translate(1298 20) translate(1)"
                        />
                        <path
                            fill="#D0D0D0"
                            d="M2 16.625c-.896 0-1.625-.729-1.625-1.625S1.104 13.375 2 13.375h.375V7.5c0-2.826 2.299-5.125 5.125-5.125h3c2.826 0 5.125 2.299 5.125 5.125v5.875H16c.896 0 1.625.729 1.625 1.625s-.729 1.625-1.625 1.625H2z"
                            transform="translate(-1298 -20) translate(1298 20) translate(1)"
                        />
                        <path
                            fill="#49565D"
                            d="M10.5 2h-3C4.475 2 2 4.475 2 7.5V13c-1.1 0-2 .9-2 2s.9 2 2 2h14c1.1 0 2-.9 2-2s-.9-2-2-2V7.5C16 4.475 13.525 2 10.5 2m0 .75c2.619 0 4.75 2.131 4.75 4.75v6.25H16c.689 0 1.25.561 1.25 1.25s-.561 1.25-1.25 1.25H2c-.689 0-1.25-.561-1.25-1.25s.561-1.25 1.25-1.25h.75V7.5c0-2.619 2.131-4.75 4.75-4.75h3"
                            transform="translate(-1298 -20) translate(1298 20) translate(1)"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const DemographicsIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="1em" height="1em" viewBox="0 0 20 18">
        <g>
            <g>
                <g>
                    <g>
                        <g>
                            <path
                                fill="none"
                                stroke="#49565D"
                                strokeWidth=".75"
                                d="M8.716 8.192h.539c.412 0 .747-.335.747-.748v-.985H8.715v1.733zM1.662 8.192h-.539c-.413 0-.748-.335-.748-.748v-.985h1.287M4.046 12.973H2.373c-1.102 0-1.996.895-1.996 1.997v2.655h9.652V14.97c0-1.102-.894-1.997-1.997-1.997h-1.7"
                                transform="translate(-39 -170) translate(0 111) translate(39 57) translate(0 2)"
                            />
                            <path
                                fill="#49565D"
                                d="M7.086 16.18L8.032 16.18 8.032 15.234 7.086 15.234z"
                                transform="translate(-39 -170) translate(0 111) translate(39 57) translate(0 2)"
                            />
                            <path
                                fill="none"
                                stroke="#49565D"
                                strokeWidth=".75"
                                d="M6.331 11.294v1.653c0 .53-.514.963-1.143.963-.628 0-1.142-.433-1.142-.963v-1.653"
                                transform="translate(-39 -170) translate(0 111) translate(39 57) translate(0 2)"
                            />
                            <path
                                fill="none"
                                stroke="#49565D"
                                strokeWidth=".75"
                                d="M2.113 3.341h6.152c.249 0 .45.202.45.451v4.433c0 1.94-1.586 3.527-3.526 3.527-1.94 0-3.527-1.587-3.527-3.527V3.792c0-.249.202-.45.45-.45z"
                                transform="translate(-39 -170) translate(0 111) translate(39 57) translate(0 2)"
                            />
                            <path
                                stroke="#49565D"
                                strokeLinecap="round"
                                strokeWidth=".75"
                                d="M3.82 8.713c.21.553.742.948 1.369.948s1.158-.395 1.369-.948"
                                transform="translate(-39 -170) translate(0 111) translate(39 57) translate(0 2)"
                            />
                            <path
                                fill="inherit"
                                d="M10.003.375H2.597C1.37.375.376 1.37.376 2.597v3.862h1.287V3.792c0-.249.2-.451.45-.451h6.152c.249 0 .45.202.45.451v2.667h1.288V.375z"
                                transform="translate(-39 -170) translate(0 111) translate(39 57) translate(0 2)"
                            />
                            <path
                                fill="none"
                                stroke="#49565D"
                                strokeWidth=".75"
                                d="M10.003.375H2.597C1.37.375.376 1.37.376 2.597v3.862h1.287V3.792c0-.249.2-.451.45-.451h6.152c.249 0 .45.202.45.451v2.667h1.288V.375zM18.587 10.062h.426c.327 0 .592-.265.592-.591v-.779h-1.018M13.012 10.062h-.426c-.327 0-.592-.265-.592-.591v-.779h1.018M14.897 13.841h-1.323c-.872 0-1.58.707-1.58 1.58v2.204h7.632V15.42c0-.872-.708-1.579-1.58-1.579h-1.343"
                                transform="translate(-39 -170) translate(0 111) translate(39 57) translate(0 2)"
                            />
                            <path
                                fill="#49565D"
                                d="M17.299 16.454L18.047 16.454 18.047 15.706 17.299 15.706z"
                                transform="translate(-39 -170) translate(0 111) translate(39 57) translate(0 2)"
                            />
                            <path
                                fill="none"
                                stroke="#49565D"
                                strokeWidth=".75"
                                d="M16.702 12.514v1.307c0 .418-.406.76-.903.76-.496 0-.903-.342-.903-.76v-1.307"
                                transform="translate(-39 -170) translate(0 111) translate(39 57) translate(0 2)"
                            />
                            <path
                                fill="none"
                                stroke="#49565D"
                                strokeWidth=".75"
                                d="M13.368 6.229h4.862c.197 0 .357.159.357.356v3.503c0 1.535-1.255 2.789-2.788 2.789s-2.787-1.255-2.787-2.789V6.585c0-.197.16-.356.356-.356z"
                                transform="translate(-39 -170) translate(0 111) translate(39 57) translate(0 2)"
                            />
                            <path
                                stroke="#49565D"
                                strokeLinecap="round"
                                strokeWidth=".75"
                                d="M14.717 10.475c.167.437.586.749 1.082.749.496 0 .916-.312 1.082-.75"
                                transform="translate(-39 -170) translate(0 111) translate(39 57) translate(0 2)"
                            />
                            <path
                                fill="inherit"
                                d="M19.604 3.884H13.75c-.969 0-1.755.786-1.755 1.756v3.053h1.017V6.585c0-.197.16-.356.356-.356h4.862c.197 0 .356.159.356.356v2.108h1.018v-4.81z"
                                transform="translate(-39 -170) translate(0 111) translate(39 57) translate(0 2)"
                            />
                            <path
                                stroke="#49565D"
                                strokeWidth=".75"
                                d="M19.604 3.884H13.75c-.969 0-1.755.786-1.755 1.756v3.053h1.017V6.585c0-.197.16-.356.356-.356h4.862c.197 0 .356.159.356.356v2.108h1.018v-4.81z"
                                transform="translate(-39 -170) translate(0 111) translate(39 57) translate(0 2)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const DataFeedIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="18" height="18" viewBox="0 0 18 18">
        <g>
            <g stroke="#49565D" strokeWidth=".75">
                <g>
                    <g>
                        <g>
                            <path
                                fill="none"
                                d="M17.625.375V15c0 .725-.294 1.381-.769 1.856-.475.475-1.131.769-1.856.769h0H3.058c.425-.644.567-1.119.567-1.615h0V.375h14z"
                                transform="translate(-40 -217) translate(0 111) translate(40 104) translate(0 2)"
                            />
                            <path
                                fill="inherit"
                                strokeLinejoin="round"
                                d="M6 3H12V6H6zM6 8H15V11H6zM6 13H15V15H6z"
                                transform="translate(-40 -217) translate(0 111) translate(40 104) translate(0 2)"
                            />
                            <path
                                fill="none"
                                d="M3.625 5.375v10.768c0 .406-.18.772-.466 1.038-.297.276-.707.444-1.159.444-.452 0-.862-.168-1.159-.444-.286-.266-.466-.632-.466-1.038h0V5.375h3.25z"
                                transform="translate(-40 -217) translate(0 111) translate(40 104) translate(0 2)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const OfflineReportsIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="18" height="18" viewBox="0 0 18 18">
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g>
                            <g>
                                <g>
                                    <path
                                        stroke="#49565D"
                                        strokeWidth=".75"
                                        d="M13 .375L13.625 15 1 15.625.375 1 13 .375z"
                                        transform="translate(-42 -622) translate(0 111) translate(0 79) translate(0 417) translate(42 15) matrix(-1 0 0 1 14 0)"
                                    />
                                    <path
                                        fill="#49565D"
                                        d="M2 2.917L12 2.917 12 2.083 2 2.083zM6 4.917L12 4.917 12 4.083 6 4.083zM9 6.917L12 6.917 12 6.083 9 6.083z"
                                        transform="translate(-42 -622) translate(0 111) translate(0 79) translate(0 417) translate(42 15) matrix(-1 0 0 1 14 0)"
                                    />
                                </g>
                                <path
                                    fill="#676DFD"
                                    stroke="#h49565D"
                                    strokeWidth=".75"
                                    d="M17.625 11.5c0 3.377-2.748 6.125-6.125 6.125S5.375 14.877 5.375 11.5 8.123 5.375 11.5 5.375s6.125 2.748 6.125 6.125"
                                    transform="translate(-42 -622) translate(0 111) translate(0 79) translate(0 417) translate(42 15)"
                                />
                                <path
                                    stroke="#FFF"
                                    strokeWidth=".75"
                                    d="M11 8.5L11 14.5"
                                    transform="translate(-42 -622) translate(0 111) translate(0 79) translate(0 417) translate(42 15) rotate(-90 11 11.5)"
                                />
                                <path
                                    stroke="#FFF"
                                    strokeWidth=".75"
                                    d="M15.003 10.5L13.004 12.501 11.003 10.5"
                                    transform="translate(-42 -622) translate(0 111) translate(0 79) translate(0 417) translate(42 15) rotate(-90 13.003 11.5)"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const OfflineReportViewMapIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 0.75H13C13.1381 0.75 13.25 0.861929 13.25 1V15C13.25 15.1381 13.1381 15.25 13 15.25H1C0.861929 15.25 0.75 15.1381 0.75 15V1C0.75 0.861929 0.861929 0.75 1 0.75ZM13 0C13.5523 0 14 0.447715 14 1V15C14 15.5523 13.5523 16 13 16H1C0.447716 16 0 15.5523 0 15V1C0 0.447715 0.447716 0 1 0H13Z"
            fill="#49565D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2.9165H2V2.0835H12V2.9165Z"
            fill="#49565D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 4.9165H2V4.0835H8V4.9165Z"
            fill="#49565D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 6.9165H2V6.0835H5V6.9165Z"
            fill="#49565D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.625 11.5C17.625 14.877 14.877 17.625 11.5 17.625C8.123 17.625 5.375 14.877 5.375 11.5C5.375 8.123 8.123 5.375 11.5 5.375C14.877 5.375 17.625 8.123 17.625 11.5Z"
            fill="#676DFD"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.75 11.5C5.75 14.6699 8.33011 17.25 11.5 17.25C14.6699 17.25 17.25 14.6699 17.25 11.5C17.25 8.33011 14.6699 5.75 11.5 5.75C8.33011 5.75 5.75 8.33011 5.75 11.5ZM11.5 18C7.91589 18 5 15.0841 5 11.5C5 7.91589 7.91589 5 11.5 5C15.0841 5 18 7.91589 18 11.5C18 15.0841 15.0841 18 11.5 18Z"
            fill="#49565D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 11.8749H8V11.1249H14V11.8749Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4732 11.4996L11.7378 13.2349L12.2682 13.7653L14.534 11.4994L12.2681 9.23486L11.7379 9.76535L13.4732 11.4996Z"
            fill="white"
        />
    </svg>
);

const InfoIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="16" height="16" viewBox="0 0 16 16">
        <g fill="none" fillRule="evenodd">
            <g>
                <g transform="translate(-493 -1245) translate(493 1245)">
                    <rect
                        width="15.25"
                        height="15.25"
                        x=".375"
                        y=".375"
                        stroke="#49565D"
                        strokeWidth=".75"
                        rx="7.625"
                    />
                    <text fill="#49565D" fontFamily="OpenSans, Open Sans" fontSize="11">
                        <tspan x="6.609" y="12">
                            i
                        </tspan>
                    </text>
                </g>
            </g>
        </g>
    </svg>
);

const HouseholdCharacteristicsIconSvg = (
    props: CustomIconComponentProps | SVGProps<SVGSVGElement>,
) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 20 18">
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <path
                        d="M0 18L20 18 20 0 0 0z"
                        transform="translate(-643 -672) translate(643 672)"
                    />
                    <g>
                        <path
                            d="M0 0H20V18H0z"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                        <path
                            fill="currentColor"
                            fillRule="nonzero"
                            stroke="#49565D"
                            strokeWidth=".75"
                            d="M9.5 2.6H2.8C1.3 2.6 0 3.9 0 5.4v11.8h9.5V2.6z"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                        <path
                            fill="#FFF"
                            fillRule="nonzero"
                            stroke="#49565D"
                            strokeWidth=".75"
                            d="M3.4 14.4H1.9c-1 0-1.8.7-1.8 1.7V18h8.6v-1.9c0-.9-.8-1.7-1.8-1.7H5.4"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                        <path
                            fill="#FFF"
                            fillRule="nonzero"
                            stroke="#49565D"
                            strokeWidth=".75"
                            d="M5.6 12.8V14c0 .5-.5 1-1.2 1h0c-.6 0-1.2-.4-1.2-1v-1.2"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                        <path
                            fill="#FFF"
                            fillRule="nonzero"
                            stroke="#49565D"
                            strokeLinejoin="round"
                            strokeWidth=".75"
                            d="M4.4 13.2h0c-1.7 0-3.1-1.4-3.1-3.1V6.6h6.3v3.5c-.1 1.7-1.5 3.1-3.2 3.1z"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                        <path
                            stroke="#49565D"
                            strokeLinecap="round"
                            strokeWidth=".75"
                            d="M3.1 10.4c.2.5.7.9 1.2.9s1.1-.4 1.2-.9"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                        <path
                            fill="currentColor"
                            fillRule="nonzero"
                            stroke="#49565D"
                            strokeWidth=".75"
                            d="M14.9 15.2h-1.1c-1 0-1.8.7-1.8 1.7V18h7.7v-1.1c0-.9-.8-1.7-1.8-1.7h-1.1"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                        <path
                            fill="#FFF"
                            fillRule="nonzero"
                            stroke="#49565D"
                            strokeWidth=".75"
                            d="M17.1 14.1v.7c0 .5-.5 1-1.2 1h0c-.6 0-1.2-.4-1.2-1v-.6M18.8 8.4h.3c.4 0 .7.3.7.7v.3c0 .5-.4 1-1 1h0"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                        <path
                            fill="#FFF"
                            fillRule="nonzero"
                            stroke="#49565D"
                            strokeWidth=".4"
                            d="M13 8.4h-.3c-.4 0-.7.3-.7.7v.3c0 .5.4 1 1 1h0"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                        <path
                            fill="#FFF"
                            fillRule="nonzero"
                            stroke="#49565D"
                            strokeLinejoin="round"
                            strokeWidth=".75"
                            d="M15.6 14.3h0c-1.7 0-3.1-1.4-3.1-3.1V8.3c0-1.7 1.4-3.1 3.1-3.1h0c1.7 0 3.1 1.4 3.1 3.1v2.9c0 1.7-1.4 3.1-3.1 3.1z"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                        <path
                            stroke="#49565D"
                            strokeLinecap="round"
                            strokeWidth=".75"
                            d="M14.4 11.5c.2.5.7.9 1.2.9.6 0 1.1-.4 1.2-.9"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                        <path
                            fill="currentColor"
                            fillRule="nonzero"
                            stroke="#49565D"
                            strokeWidth=".75"
                            d="M6.1 2.8c0-.8.711-.8 1.611-.8H13c1 0 2.1.8 2.1 1.8 0 0 .1 2.9.1 3.5 0 1.1-1.4 1.3-1.4 1.3V5.5c0-.4-.3-.7-.5-.7h-5c-.4 0-.8.3-.8.7V8.6c-.4 0-1.4-.6-1.4-1.7V2.8z"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                        <path
                            fill="#FFF"
                            fillRule="nonzero"
                            stroke="#49565D"
                            strokeWidth=".75"
                            d="M9.9 14H7.7c-.9 0-1.6.7-1.6 1.5v2.4H15v-2.4c0-.8-.7-1.5-1.6-1.5h-1.7"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                        <path
                            fill="#FFF"
                            fillRule="nonzero"
                            stroke="#49565D"
                            strokeWidth=".75"
                            d="M11.7 12.7L11.7 14 10.6 14.7 10.6 14.7 9.5 14 9.5 12.7"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                        <path
                            fill="currentColor"
                            fillRule="nonzero"
                            stroke="#49565D"
                            strokeWidth=".75"
                            d="M11.8 15.8L10.6 14.8 9.4 15.8 10 17.9 11.1 17.9z"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                        <path
                            fill="#FFF"
                            fillRule="nonzero"
                            stroke="#49565D"
                            strokeLinejoin="round"
                            strokeWidth=".75"
                            d="M10.6 12.9h0c-1.7 0-3.1-1.4-3.1-3.1V5.7c-.1-.8.4-.9 1-.9h4.4c.5 0 .8 0 .8.7v4.3c0 1.7-1.4 3.1-3.1 3.1z"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                        <path
                            stroke="#49565D"
                            strokeLinecap="round"
                            strokeWidth=".75"
                            d="M9.3 9.9c.2.5.7.9 1.2.9s1.1-.4 1.2-.9"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                        <path
                            stroke="#49565D"
                            strokeLinecap="round"
                            d="M12.2 9.5c-.5-.2-1.1-.3-1.6-.3-.6 0-1.1.1-1.6.3"
                            transform="translate(-643 -672) translate(643 672)"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const CoTenantsIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" {...props}>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g>
                            <g>
                                <g>
                                    <g>
                                        <g>
                                            <path
                                                d="M0 9.454L2.381 9.454 2.381 0.557 0 0.557z"
                                                transform="translate(-642 -758) translate(40 171) translate(0 -46) translate(290 376) translate(32 41) translate(280 213) translate(0 3)"
                                            />
                                            <path
                                                stroke="#49565D"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth=".51"
                                                d="M0 9.454L2.381 9.454 2.381 0.557 0 0.557z"
                                                transform="translate(-642 -758) translate(40 171) translate(0 -46) translate(290 376) translate(32 41) translate(280 213) translate(0 3)"
                                            />
                                            <path
                                                fill="#D0D0D0"
                                                d="M17.619 9.454L20 9.454 20 0.557 17.619 0.557z"
                                                transform="translate(-642 -758) translate(40 171) translate(0 -46) translate(290 376) translate(32 41) translate(280 213) translate(0 3)"
                                            />
                                            <g>
                                                <path
                                                    stroke="#49565D"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth=".5"
                                                    d="M15.238 9.454L17.619 9.454 17.619 0.557 15.238 0.557z"
                                                    transform="translate(-642 -758) translate(40 171) translate(0 -46) translate(290 376) translate(32 41) translate(280 213) translate(0 3) translate(2.381)"
                                                />
                                                <path
                                                    d="M13.146 8.186l-4.302-4.23-.412-.405c-.022-.021-.046-.036-.068-.055L6.638 1.844C5.496.72 3.643.72 2.5 1.844l-.119.118H0v6.087h2.857l3.466 3.408c.284.28.75.28 1.034 0 .284-.28.284-.737 0-1.017l.558.549c.37.364.976.364 1.346 0 .37-.365.37-.96 0-1.325l.715.702c.37.365.976.365 1.347 0 .37-.363.37-.96 0-1.324l.476.469c.37.364.976.364 1.347 0 .37-.364.37-.96 0-1.325"
                                                    transform="translate(-642 -758) translate(40 171) translate(0 -46) translate(290 376) translate(32 41) translate(280 213) translate(0 3) translate(2.381)"
                                                />
                                                <path
                                                    fill="#D0D0D0"
                                                    stroke="#49565D"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth=".51"
                                                    d="M13.146 8.186l-4.302-4.23h0l-.412-.405c-.022-.021-.046-.036-.068-.055L6.638 1.844C5.496.72 3.643.72 2.5 1.844l-.119.118H0v6.087h2.857l3.466 3.408c.284.28.75.28 1.034 0 .284-.28.284-.737 0-1.017l.558.549c.37.364.976.364 1.346 0 .37-.365.37-.96 0-1.325l.715.702c.37.365.976.365 1.347 0 .37-.363.37-.96 0-1.324l.476.469c.37.364.976.364 1.347 0 .37-.364.37-.96 0-1.325z"
                                                    transform="translate(-642 -758) translate(40 171) translate(0 -46) translate(290 376) translate(32 41) translate(280 213) translate(0 3) translate(2.381)"
                                                />
                                                <path
                                                    fill="#FFF"
                                                    d="M7.75 2.884L5.414 5.18c-.797.782-2.088.782-2.884 0l-.578-.57 3.475-3.417c1.632-1.604 4.423-1.584 6.054.02l1.454 1.43v-.681h2.302v6.087h-2.232L7.75 2.884z"
                                                    transform="translate(-642 -758) translate(40 171) translate(0 -46) translate(290 376) translate(32 41) translate(280 213) translate(0 3) translate(2.381)"
                                                />
                                                <path
                                                    stroke="#49565D"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth=".51"
                                                    d="M7.75 2.884L5.414 5.18c-.797.782-2.088.782-2.884 0l-.578-.57 3.475-3.417c1.632-1.604 4.423-1.584 6.054.02l1.454 1.43v-.681h2.302v6.087h-2.232L7.75 2.884z"
                                                    transform="translate(-642 -758) translate(40 171) translate(0 -46) translate(290 376) translate(32 41) translate(280 213) translate(0 3) translate(2.381)"
                                                />
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const EmptyCreditCountIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        {...props}
        width="30px"
        height="30px"
        viewBox="0 0 30 30"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Group-5">
                <circle
                    id="Oval"
                    fill="#5E63E5"
                    opacity="0.119999997"
                    cx="15"
                    cy="15"
                    r="15"
                ></circle>
                <circle id="Oval" fill="#5E63E5" cx="15" cy="15" r="9"></circle>
                <g
                    id="Icons_18/Blue/Coin"
                    transform="translate(6.000000, 6.000000)"
                    fill="#FFFFFF"
                    fillRule="nonzero"
                >
                    <g id="Group-6-Copy">
                        <path
                            d="M9.49789916,15 L9.49789916,13.4008529 C10.2794118,13.336887 10.8918067,13.0895522 11.335084,12.6588486 C11.7783613,12.228145 12,11.6759062 12,11.0021322 C12,10.7675906 11.9737395,10.5511727 11.9212185,10.3528785 C11.8686975,10.1545842 11.8046218,9.98294243 11.7289916,9.83795309 C11.6533613,9.69296375 11.5409664,9.554371 11.3918067,9.42217484 C11.2426471,9.28997868 11.105042,9.18230277 10.9789916,9.09914712 C10.8529412,9.01599147 10.6743697,8.92643923 10.4432773,8.83049041 C10.2121849,8.73454158 10.0189076,8.65991471 9.86344538,8.60660981 C9.70798319,8.5533049 9.48739496,8.47974414 9.20168067,8.38592751 C8.94537815,8.30063966 8.74159664,8.22814499 8.59033613,8.1684435 C8.43907563,8.108742 8.27310924,8.03304904 8.09243697,7.94136461 C7.91176471,7.84968017 7.77415966,7.75799574 7.67962185,7.6663113 C7.58508403,7.57462687 7.5052521,7.46375267 7.44012605,7.3336887 C7.375,7.20362473 7.34243697,7.05970149 7.34243697,6.90191898 C7.34243697,6.52238806 7.48214286,6.22921109 7.76155462,6.02238806 C8.04096639,5.81556503 8.41176471,5.71215352 8.87394958,5.71215352 C9.20168067,5.71215352 9.56407563,5.7803838 9.96113445,5.91684435 C10.3581933,6.0533049 10.7184874,6.24307036 11.0420168,6.48614072 L11.0420168,6.48614072 L11.7037815,5.67377399 C11.4096639,5.4434968 11.0661765,5.24200426 10.6733193,5.06929638 C10.2804622,4.89658849 9.88865546,4.7782516 9.49789916,4.71428571 L9.49789916,4.71428571 L9.49789916,3 L8.62815126,3 L8.62815126,4.65031983 C7.8592437,4.68869936 7.25840336,4.92217484 6.82563025,5.35074627 C6.39285714,5.7793177 6.17647059,6.31982942 6.17647059,6.97228145 C6.17647059,7.18976546 6.20378151,7.391258 6.25840336,7.57675906 C6.31302521,7.76226013 6.3802521,7.92430704 6.46008403,8.06289979 C6.53991597,8.20149254 6.65441176,8.3336887 6.80357143,8.45948827 C6.95273109,8.58528785 7.09033613,8.68869936 7.21638655,8.76972281 C7.34243697,8.85074627 7.51365546,8.93710021 7.73004202,9.02878465 C7.94642857,9.12046908 8.12815126,9.19296375 8.27521008,9.24626866 C8.42226891,9.29957356 8.62184874,9.36673774 8.87394958,9.44776119 C9.1512605,9.53304904 9.375,9.60767591 9.54516807,9.67164179 C9.71533613,9.73560768 9.88970588,9.81449893 10.0682773,9.90831557 C10.2468487,10.0021322 10.3844538,10.1002132 10.4810924,10.2025586 C10.5777311,10.3049041 10.657563,10.4296375 10.7205882,10.5767591 C10.7836134,10.7238806 10.8151261,10.8891258 10.8151261,11.0724947 C10.8151261,11.4776119 10.6617647,11.7963753 10.355042,12.0287846 C10.0483193,12.261194 9.64915966,12.3773987 9.15756303,12.3773987 C8.7289916,12.3773987 8.29516807,12.2846482 7.85609244,12.0991471 C7.41701681,11.9136461 7.0210084,11.6439232 6.66806723,11.2899787 L6.66806723,11.2899787 L6,12.1023454 C6.76470588,12.8528785 7.6407563,13.2814499 8.62815126,13.3880597 L8.62815126,13.3880597 L8.62815126,15 L9.49789916,15 Z"
                            id="$"
                        ></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const CreditCountIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="30" height="30" viewBox="0 0 30 30">
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g transform="translate(-1101 -143) translate(294 127) translate(799 8) translate(8 8)">
                            <circle cx="15" cy="15" r="15" fill="#5E63E5" opacity=".12" />
                            <circle cx="15" cy="15" r="9" fill="#5E63E5" />
                            <path
                                fill="#5E63E5"
                                fillRule="nonzero"
                                d="M15 4c6.075 0 11 4.925 11 11s-4.925 11-11 11S4 21.075 4 15c0-1.986.526-3.85 1.447-5.458l.869.496C5.479 11.5 5 13.194 5 15c0 5.523 4.477 10 10 10s10-4.477 10-10S20.523 5 15 5V4z"
                            />
                            <g fill="#FFF" fillRule="nonzero">
                                <g>
                                    <path
                                        d="M3.498 12v-1.6c.781-.063 1.394-.31 1.837-.741.443-.43.665-.983.665-1.657 0-.234-.026-.45-.079-.65-.052-.197-.116-.37-.192-.514-.076-.145-.188-.284-.337-.416-.15-.132-.287-.24-.413-.323-.126-.083-.305-.173-.536-.269-.23-.095-.424-.17-.58-.223-.155-.054-.376-.127-.661-.221-.257-.085-.46-.158-.612-.218-.15-.06-.317-.135-.498-.227-.18-.091-.318-.183-.412-.275-.095-.091-.175-.202-.24-.332s-.098-.274-.098-.432c0-.38.14-.673.42-.88.279-.206.65-.31 1.112-.31.328 0 .69.068 1.087.205.397.136.757.326 1.081.57l.662-.813c-.294-.23-.638-.432-1.03-.605-.394-.172-.785-.29-1.176-.355V0h-.87v1.65c-.769.039-1.37.272-1.802.7-.433.43-.65.97-.65 1.622 0 .218.028.42.082.605.055.185.122.347.202.486.08.138.194.27.344.396.149.126.286.23.412.31.126.082.298.168.514.26.216.091.398.164.545.217.147.054.347.12.599.202.277.085.501.16.671.224.17.064.345.142.523.236.179.094.316.192.413.295.097.102.177.227.24.374s.094.312.094.495c0 .406-.153.724-.46.957-.307.232-.706.348-1.197.348-.429 0-.863-.092-1.302-.278-.439-.185-.835-.455-1.188-.809L0 9.102c.765.75 1.64 1.18 2.628 1.286V12h.87z"
                                        transform="translate(6 6) translate(6 3)"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const FullCreditCountIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="30" height="30" viewBox="0 0 30 30">
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g transform="translate(-1006 -757) translate(950 229) translate(48 520) translate(8 8)">
                            <circle cx="15" cy="15" r="15" fill="#5E63E5" opacity=".12" />
                            <circle cx="15" cy="15" r="9" fill="#5E63E5" />
                            <path
                                fill="#5E63E5"
                                fillRule="nonzero"
                                d="M15 4c6.075 0 11 4.925 11 11s-4.925 11-11 11S4 21.075 4 15 8.925 4 15 4zm0 1C9.477 5 5 9.477 5 15s4.477 10 10 10 10-4.477 10-10S20.523 5 15 5z"
                            />
                            <g fill="#FFF" fillRule="nonzero">
                                <g>
                                    <path
                                        d="M3.498 12v-1.6c.781-.063 1.394-.31 1.837-.741.443-.43.665-.983.665-1.657 0-.234-.026-.45-.079-.65-.052-.197-.116-.37-.192-.514-.076-.145-.188-.284-.337-.416-.15-.132-.287-.24-.413-.323-.126-.083-.305-.173-.536-.269-.23-.095-.424-.17-.58-.223-.155-.054-.376-.127-.661-.221-.257-.085-.46-.158-.612-.218-.15-.06-.317-.135-.498-.227-.18-.091-.318-.183-.412-.275-.095-.091-.175-.202-.24-.332s-.098-.274-.098-.432c0-.38.14-.673.42-.88.279-.206.65-.31 1.112-.31.328 0 .69.068 1.087.205.397.136.757.326 1.081.57l.662-.813c-.294-.23-.638-.432-1.03-.605-.394-.172-.785-.29-1.176-.355V0h-.87v1.65c-.769.039-1.37.272-1.802.7-.433.43-.65.97-.65 1.622 0 .218.028.42.082.605.055.185.122.347.202.486.08.138.194.27.344.396.149.126.286.23.412.31.126.082.298.168.514.26.216.091.398.164.545.217.147.054.347.12.599.202.277.085.501.16.671.224.17.064.345.142.523.236.179.094.316.192.413.295.097.102.177.227.24.374s.094.312.094.495c0 .406-.153.724-.46.957-.307.232-.706.348-1.197.348-.429 0-.863-.092-1.302-.278-.439-.185-.835-.455-1.188-.809L0 9.102c.765.75 1.64 1.18 2.628 1.286V12h.87z"
                                        transform="translate(6 6) translate(6 3)"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const SubmitRequestIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        width="16px"
        height="20px"
        viewBox="0 0 16 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Custom-Preset" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="CTA-Icon">
                <path
                    d="M14.6666667,0 L1.33333333,0 C0.597333333,0 0,0.597333333 0,1.33333333 L0,18.6666667 C0,19.4026667 0.597333333,20 1.33333333,20 L14.6666667,20 C15.4026667,20 16,19.4026667 16,18.6666667 L16,1.33333333 C16,0.597333333 15.4026667,0 14.6666667,0 M14.6666667,1 C14.8506667,1 15,1.14933333 15,1.33333333 L15,18.6666667 C15,18.8506667 14.8506667,19 14.6666667,19 L1.33333333,19 C1.14933333,19 1,18.8506667 1,18.6666667 L1,1.33333333 C1,1.14933333 1.14933333,1 1.33333333,1 L14.6666667,1"
                    id="Fill-3"
                    fill="#FFFFFF"
                ></path>
                <polygon
                    id="Fill-5"
                    fill="#FFFFFF"
                    points="10.6666667 6.5 13.3333333 6.5 13.3333333 5.5 10.6666667 5.5"
                ></polygon>
                <polygon
                    id="Fill-7"
                    fill="#FFFFFF"
                    transform="translate(7.334041, 12.671331) rotate(-181.000000) translate(-7.334041, -12.671331) "
                    points="3.17204071 13.1713313 11.4960407 13.1713313 11.4960407 12.1713313 3.17204071 12.1713313"
                ></polygon>
                <polygon
                    id="Fill-8"
                    fill="#FFFFFF"
                    points="2.66666667 6.5 9.33333333 6.5 9.33333333 5.5 2.66666667 5.5"
                ></polygon>
                <polygon
                    id="Fill-9"
                    fill="#FFFFFF"
                    points="2.66666667 3.83333333 4 3.83333333 4 2.83333333 2.66666667 2.83333333"
                ></polygon>
                <polygon
                    id="Fill-10"
                    fill="#FFFFFF"
                    points="2.66666667 3.83333333 13.3333333 3.83333333 13.3333333 2.83333333 2.66666667 2.83333333"
                ></polygon>
                <polyline
                    id="Stroke-11"
                    stroke="#FFFFFF"
                    strokeWidth="0.75"
                    transform="translate(10.585543, 12.614443) rotate(-181.000000) translate(-10.585543, -12.614443) "
                    points="11.9995431 15.4424428 9.17154309 12.6144428 11.9995431 9.78644278"
                ></polyline>
            </g>
        </g>
    </svg>
);

const CircleDownloadIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="16" height="16" viewBox="0 0 16 16">
        <g fill="none" fillRule="evenodd">
            <g fill="#49565D">
                <g>
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M4.923 12.154h6.154v-.923H4.923v.923zm2.615-2.308h.018L8 10.29l.446-.444h.016V9.83l1.901-1.903-.653-.65-1.248 1.248V3.692h-.924v4.832L6.29 7.274l-.654.653L7.538 9.83v.017zM8 15.076C4.097 15.077.923 11.904.923 8 .923 4.097 4.097.923 8 .923c3.902 0 7.077 3.174 7.077 7.077S11.902 15.077 8 15.077zM8 0C3.582 0 0 3.582 0 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8z"
                                    transform="translate(-371 -723) translate(293 327) translate(48 88) translate(16 296) translate(14 12)"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const EditTableIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        width="19"
        height="19"
        {...props}
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Color=gray">
            <path
                id="Stroke 16"
                d="M0.500044 9H10.6041"
                stroke="#49565D"
                strokeWidth="0.75"
                strokeLinecap="round"
            />
            <path
                id="Fill 1"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.005 0.379883C17.1096 0.379883 18.005 1.27531 18.005 2.37988L18.005 4.8L0.00500469 4.8L0.0050048 2.37988C0.00500484 1.27531 0.900434 0.379882 2.005 0.379882L16.005 0.379883Z"
                fill="#D0D0D0"
            />
            <path id="Stroke 12" d="M18.005 4.5H0.00500488" stroke="#49565D" strokeWidth="0.75" />
            <path id="Stroke 13" d="M5.505 18L5.505 4.19995" stroke="#49565D" strokeWidth="0.75" />
            <path
                id="Stroke 15"
                d="M12.13 7.00758C12.13 7.21469 12.2979 7.38258 12.505 7.38258C12.7121 7.38258 12.88 7.21469 12.88 7.00758L12.13 7.00758ZM12.88 7.00758L12.88 4.19995L12.13 4.19995L12.13 7.00758L12.88 7.00758Z"
                fill="#49565D"
            />
            <g id="Icons_18/Gray/List-Table">
                <path
                    id="Rectangle"
                    d="M6.63 17.6299H2.38C1.27543 17.6299 0.379997 16.7345 0.379997 15.6299V2.37988C0.379997 1.27531 1.27543 0.379883 2.38 0.379883H15.63C16.7346 0.379883 17.63 1.27531 17.63 2.37988V6.99988"
                    stroke="#49565D"
                    strokeWidth="0.75"
                    strokeLinecap="round"
                />
                <path
                    id="Rectangle_2"
                    d="M17.63 13.3799V15.6299C17.63 16.7345 16.7346 17.6299 15.63 17.6299H13.38"
                    stroke="#49565D"
                    strokeWidth="0.75"
                    strokeLinecap="round"
                />
            </g>
            <g id="Edit icon Copy">
                <g id="Group 2">
                    <path
                        id="Stroke 1"
                        d="M11.517 16.7107L8.5 17.4999L9.28925 14.4829"
                        stroke="#49565D"
                        strokeWidth="0.75"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Stroke 3"
                        d="M14.2243 9.54831L15.1052 8.65509L15.2763 8.6169C16.5679 8.32852 17.735 9.45198 17.4959 10.7537V10.7537L16.4521 11.7761"
                        stroke="#49565D"
                        strokeWidth="0.75"
                        strokeLinecap="round"
                    />
                    <path
                        id="Fill 5"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.517 16.7108L9.28925 14.483L14.2763 9.49658L16.5035 11.7244L11.517 16.7108Z"
                        fill="#D0D0D0"
                    />
                    <path
                        id="Stroke 7"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.517 16.7108L9.28925 14.483L14.2763 9.49658L16.5035 11.7244L11.517 16.7108Z"
                        stroke="#49565D"
                        strokeWidth="0.75"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </g>
            <path
                id="Stroke 17"
                d="M0.5 13.5H7.5"
                stroke="#49565D"
                strokeWidth="0.75"
                strokeLinecap="round"
            />
        </g>
    </svg>
);

const GrayOfflineReportIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="18" height="18" viewBox="0 0 18 18">
        <g fill="none" fillRule="evenodd">
            <path
                stroke="#49565D"
                strokeWidth=".75"
                d="M13 .375L13.625 15 1 15.625.375 1 13 .375z"
                transform="translate(-1199 -182) translate(290 167) translate(890 5) translate(19 10) matrix(-1 0 0 1 14 0)"
            />
            <path
                fill="#49565D"
                d="M2 2.917L12 2.917 12 2.083 2 2.083zM6 4.917L12 4.917 12 4.083 6 4.083zM9 6.917L12 6.917 12 6.083 9 6.083z"
                transform="translate(-1199 -182) translate(290 167) translate(890 5) translate(19 10) matrix(-1 0 0 1 14 0)"
            />
            <path
                fill="#D0D0D0"
                stroke="#49565D"
                strokeWidth=".75"
                d="M17.625 11.5c0 3.377-2.748 6.125-6.125 6.125S5.375 14.877 5.375 11.5 8.123 5.375 11.5 5.375s6.125 2.748 6.125 6.125"
                transform="translate(-1199 -182) translate(290 167) translate(890 5) translate(19 10)"
            />
            <path
                stroke="#49565D"
                strokeWidth=".75"
                d="M11 8.5L11 14.5"
                transform="translate(-1199 -182) translate(290 167) translate(890 5) translate(19 10) rotate(-90 11 11.5)"
            />
            <path
                stroke="#49565D"
                strokeWidth=".75"
                d="M15.003 10.5L13.004 12.501 11.003 10.5"
                transform="translate(-1199 -182) translate(290 167) translate(890 5) translate(19 10) rotate(-90 13.003 11.5)"
            />
        </g>
    </svg>
);

const GrayOfflineReportViewMapIconSvg = (
    props: CustomIconComponentProps | SVGProps<SVGSVGElement>,
) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 0.75H13C13.1381 0.75 13.25 0.861929 13.25 1V15C13.25 15.1381 13.1381 15.25 13 15.25H1C0.861929 15.25 0.75 15.1381 0.75 15V1C0.75 0.861929 0.861929 0.75 1 0.75ZM13 0C13.5523 0 14 0.447715 14 1V15C14 15.5523 13.5523 16 13 16H1C0.447716 16 0 15.5523 0 15V1C0 0.447715 0.447716 0 1 0H13Z"
            fill="#49565D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2.9165H2V2.0835H12V2.9165Z"
            fill="#49565D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 4.9165H2V4.0835H8V4.9165Z"
            fill="#49565D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 6.9165H2V6.0835H5V6.9165Z"
            fill="#49565D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.625 11.5C17.625 14.877 14.877 17.625 11.5 17.625C8.123 17.625 5.375 14.877 5.375 11.5C5.375 8.123 8.123 5.375 11.5 5.375C14.877 5.375 17.625 8.123 17.625 11.5Z"
            fill="#D0D0D0"
            className="arrow"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.75 11.5C5.75 14.6699 8.33011 17.25 11.5 17.25C14.6699 17.25 17.25 14.6699 17.25 11.5C17.25 8.33011 14.6699 5.75 11.5 5.75C8.33011 5.75 5.75 8.33011 5.75 11.5ZM11.5 18C7.91589 18 5 15.0841 5 11.5C5 7.91589 7.91589 5 11.5 5C15.0841 5 18 7.91589 18 11.5C18 15.0841 15.0841 18 11.5 18Z"
            fill="#49565D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 11.875H8V11.125H14V11.875Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4732 11.4997L11.7378 13.235L12.2682 13.7654L14.534 11.4995L12.2681 9.23496L11.7379 9.76545L13.4732 11.4997Z"
            fill="currentColor"
        />
    </svg>
);

const PaperClipIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
    >
        <path
            opacity="0.15"
            d="M11.2967 6.5471L12.7498 8.00023L7.62107 13.1215C7.05691 13.6765 6.29629 13.9861 5.50487 13.9829C4.71346 13.9797 3.95539 13.6639 3.39577 13.1043C2.83615 12.5447 2.52034 11.7866 2.51711 10.9952C2.51389 10.2038 2.82352 9.44313 3.37856 8.87898L9.58544 2.58585C9.96056 2.21074 10.4693 2 10.9998 2C11.5303 2 12.0391 2.21074 12.4142 2.58585C12.7893 2.96097 13 3.46973 13 4.00023C13 4.53072 12.7893 5.03949 12.4142 5.4146L11.2967 6.5471Z"
            fill="#49565D"
        />
        <path
            d="M13.1035 7.64644C13.15 7.69288 13.1869 7.74802 13.2121 7.80872C13.2372 7.86942 13.2502 7.93449 13.2502 8.00019C13.2502 8.0659 13.2372 8.13097 13.2121 8.19166C13.1869 8.25236 13.15 8.30751 13.1035 8.35394L7.9754 13.4789C7.31891 14.1354 6.42854 14.5041 5.50018 14.504C4.57182 14.504 3.6815 14.1351 3.02509 13.4786C2.36868 12.8221 1.99994 11.9318 2 11.0034C2.00006 10.075 2.36891 9.18473 3.0254 8.52832L9.22915 2.23332C9.69784 1.76413 10.3337 1.50035 10.9969 1.5C11.6601 1.49965 12.2962 1.76276 12.7654 2.23144C13.2346 2.70013 13.4984 3.33601 13.4987 3.99918C13.4991 4.66236 13.236 5.29851 12.7673 5.76769L6.56227 12.0627C6.28048 12.3445 5.89829 12.5028 5.49977 12.5028C5.10126 12.5028 4.71907 12.3445 4.43727 12.0627C4.15548 11.7809 3.99717 11.3987 3.99717 11.0002C3.99717 10.6017 4.15548 10.2195 4.43727 9.93769L9.64353 4.64894C9.68913 4.60029 9.74401 4.56126 9.80493 4.53413C9.86585 4.50701 9.93158 4.49234 9.99825 4.491C10.0649 4.48966 10.1312 4.50166 10.1931 4.52632C10.2551 4.55097 10.3115 4.58776 10.359 4.63454C10.4066 4.68132 10.4443 4.73713 10.4699 4.79869C10.4955 4.86025 10.5086 4.92632 10.5083 4.993C10.508 5.05969 10.4944 5.12564 10.4683 5.18698C10.4421 5.24833 10.4039 5.30382 10.356 5.35019L5.14915 10.6446C5.10253 10.6908 5.06548 10.7458 5.04011 10.8064C5.01473 10.8669 5.00154 10.9319 5.00128 10.9976C5.00102 11.0632 5.01369 11.1283 5.03858 11.1891C5.06347 11.2499 5.10009 11.3051 5.14634 11.3518C5.19259 11.3984 5.24757 11.4354 5.30814 11.4608C5.36871 11.4862 5.43368 11.4994 5.49935 11.4996C5.56502 11.4999 5.63009 11.4872 5.69086 11.4623C5.75163 11.4374 5.80691 11.4008 5.85353 11.3546L12.0579 5.06269C12.3397 4.78148 12.4982 4.39985 12.4986 4.00174C12.4991 3.60364 12.3413 3.22167 12.0601 2.93988C11.7789 2.65809 11.3972 2.49955 10.9991 2.49914C10.601 2.49873 10.2191 2.65648 9.93728 2.93769L3.73477 9.23019C3.50242 9.46218 3.31803 9.73767 3.19214 10.0409C3.06624 10.3442 3.00131 10.6692 3.00105 10.9976C3.00079 11.3259 3.0652 11.6511 3.19061 11.9545C3.31602 12.258 3.49997 12.5338 3.73196 12.7661C3.96395 12.9985 4.23943 13.1829 4.54268 13.3088C4.84593 13.4347 5.17101 13.4996 5.49935 13.4999C5.82769 13.5001 6.15287 13.4357 6.45632 13.3103C6.75977 13.1849 7.03554 13.0009 7.2679 12.7689L12.3967 7.64394C12.4907 7.55058 12.6181 7.49839 12.7506 7.49886C12.8832 7.49933 13.0101 7.55241 13.1035 7.64644Z"
            fill="#49565D"
        />
    </svg>
);

const DownloadSmallIconIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 1C8.41421 1 8.75 1.33579 8.75 1.75V9.43934L11.9697 6.21967C12.2626 5.92678 12.7374 5.92678 13.0303 6.21967C13.3232 6.51256 13.3232 6.98744 13.0303 7.28033L8.53033 11.7803C8.38388 11.9268 8.19194 12 8 12C7.89831 12 7.80134 11.9798 7.71291 11.9431C7.62445 11.9065 7.54158 11.8522 7.46967 11.7803L2.96967 7.28033C2.67678 6.98744 2.67678 6.51256 2.96967 6.21967C3.26256 5.92678 3.73744 5.92678 4.03033 6.21967L7.25 9.43934V1.75C7.25 1.33579 7.58579 1 8 1ZM2.5 13C2.08579 13 1.75 13.3358 1.75 13.75C1.75 14.1642 2.08579 14.5 2.5 14.5H13.5C13.9142 14.5 14.25 14.1642 14.25 13.75C14.25 13.3358 13.9142 13 13.5 13H2.5Z"
            fill="#49565D"
        />
    </svg>
);

const PopularityScoreIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="18" height="18" viewBox="0 0 18 18">
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g>
                            <g>
                                <g transform="translate(-594 -569) translate(293 327) translate(48 88) translate(248 151) translate(5 3) translate(1.38 .37)">
                                    <g>
                                        <path
                                            stroke="#9D9D9D"
                                            strokeWidth=".75"
                                            d="M8.34 8.13h.54c.412 0 .747-.337.747-.75V6.084H8.34V8.13zM1.287 8.13H.748C.335 8.13 0 7.793 0 7.38V6.084h1.287"
                                        />
                                        <path
                                            stroke="#9D9D9D"
                                            strokeLinecap="round"
                                            strokeWidth=".75"
                                            d="M3.671 12.598H1.997C.894 12.598 0 13.493 0 14.595v2.655h9.653"
                                        />
                                        <path
                                            stroke="#9D9D9D"
                                            strokeWidth=".75"
                                            d="M5.956 10.919v1.653c0 .53-.514.963-1.143.963-.628 0-1.142-.433-1.142-.963v-1.653"
                                        />
                                        <path
                                            stroke="#9D9D9D"
                                            strokeWidth=".75"
                                            d="M6.144 11.115c-.411.17-.86.262-1.33.262-1.94 0-3.527-1.587-3.527-3.527V3.417"
                                        />
                                        <path
                                            stroke="#9D9D9D"
                                            strokeLinecap="round"
                                            strokeWidth=".75"
                                            d="M3.445 8.338c.21.553.742.948 1.369.948s1.158-.395 1.369-.948"
                                        />
                                        <path d="M9.627 0H2.221C.994 0 .001.995.001 2.222v3.862h1.286V3.417c0-.249.201-.451.45-.451H7.89c.25 0 .451.202.451.451v2.667h1.287V0z" />
                                        <path
                                            stroke="#9D9D9D"
                                            strokeWidth=".75"
                                            d="M9.627 0H2.221C.994 0 .001.995.001 2.222v3.862h1.286V3.417c0-.249.201-.451.45-.451H7.89c.25 0 .451.202.451.451v2.667h1.287V0z"
                                        />
                                    </g>
                                    <circle
                                        cx="10.625"
                                        cy="12.625"
                                        r="4.625"
                                        stroke="#9D9D9D"
                                        strokeWidth=".75"
                                    />
                                    <path
                                        stroke="#9D9D9D"
                                        strokeLinecap="round"
                                        strokeWidth=".75"
                                        d="M12.625 11.125L9.918 14.125 8.625 12.691"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const PopularityScoreWhiteIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="17" height="18" viewBox="0 0 17 18">
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g>
                            <g>
                                <g>
                                    <path
                                        d="M0 0L16.353 0 16.353 18 0 18z"
                                        transform="translate(-766 -1413) translate(293 863) translate(32 80) translate(268 357) translate(165.647 106) translate(8 7)"
                                    />
                                    <path
                                        fill="#FFF"
                                        fillRule="nonzero"
                                        d="M8.044 9c1.658 0 3-1.343 3-3s-1.342-3-3-3c-1.657 0-3 1.343-3 3s1.343 3 3 3zm0-4.5c.825 0 1.5.675 1.5 1.5s-.675 1.5-1.5 1.5-1.5-.675-1.5-1.5.675-1.5 1.5-1.5zm-4.5 9c.15-.473 1.928-1.26 3.72-1.455l1.53-1.5c-.292-.03-.51-.045-.75-.045-2.002 0-6 1.005-6 3V15h6.75l-1.5-1.5h-3.75zm11.7-4.125l-3.847 3.877-1.553-1.56-1.05 1.058 2.603 2.625 4.897-4.943-1.05-1.057z"
                                        transform="translate(-766 -1413) translate(293 863) translate(32 80) translate(268 357) translate(165.647 106) translate(8 7)"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const PencilIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="28" height="28" viewBox="0 0 28 28">
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M0 0H28V28H0z"
                                    transform="translate(-1039 -704) translate(193 79) translate(0 595) translate(838 24) translate(8 6)"
                                />
                                <g stroke="#FFF" strokeWidth=".825">
                                    <g>
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M6.671 15.941L0.814 17.473 2.346 11.616"
                                            transform="translate(-1039 -704) translate(193 79) translate(0 595) translate(838 24) translate(8 6) translate(4 4)"
                                        />
                                        <path
                                            strokeLinecap="round"
                                            d="M11.928 2.035L13.64.323c.43-.43 1.127-.43 1.556 0l2.77 2.768c.429.43.429 1.127 0 1.557L16.253 6.36"
                                            transform="translate(-1039 -704) translate(193 79) translate(0 595) translate(838 24) translate(8 6) translate(4 4)"
                                        />
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M6.671 15.941L2.346 11.616 12.028 1.935 16.353 6.26z"
                                            transform="translate(-1039 -704) translate(193 79) translate(0 595) translate(838 24) translate(8 6) translate(4 4)"
                                        />
                                        <path
                                            d="M9.58 8.707L6.645 11.643M18.7 18.837L0 18.837"
                                            transform="translate(-1039 -704) translate(193 79) translate(0 595) translate(838 24) translate(8 6) translate(4 4)"
                                        />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const UploadIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="16" height="18" viewBox="0 0 16 18">
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g>
                            <g>
                                <path
                                    fill="#D0D0D0"
                                    d="M10.108 0v4.142c0 .551.448 1 1 1h4.142"
                                    transform="translate(-113 -534) translate(48 48) translate(48 450) translate(0 23) translate(17.375 13.375)"
                                />
                                <path
                                    stroke="#49565D"
                                    strokeLinecap="round"
                                    strokeWidth=".75"
                                    d="M10.108 0v4.142c0 .551.448 1 1 1h4.142"
                                    transform="translate(-113 -534) translate(48 48) translate(48 450) translate(0 23) translate(17.375 13.375)"
                                />
                                <path
                                    stroke="#49565D"
                                    strokeLinecap="round"
                                    strokeWidth=".75"
                                    d="M1 17.25h13.25c.553 0 1-.447 1-1V4.904L10.346 0H1C.448 0 0 .447 0 1v15.25c0 .553.448 1 1 1z"
                                    transform="translate(-113 -534) translate(48 48) translate(48 450) translate(0 23) translate(17.375 13.375)"
                                />
                                <path
                                    stroke="#49565D"
                                    strokeWidth=".75"
                                    d="M7.625 6.35L7.625 12.209"
                                    transform="translate(-113 -534) translate(48 48) translate(48 450) translate(0 23) translate(17.375 13.375) matrix(1 0 0 -1 0 18.558)"
                                />
                                <path
                                    stroke="#49565D"
                                    strokeWidth=".75"
                                    d="M9.916 6.177L7.625 8.468 5.334 6.177"
                                    transform="translate(-113 -534) translate(48 48) translate(48 450) translate(0 23) translate(17.375 13.375) matrix(1 0 0 -1 0 14.645)"
                                />
                                <path
                                    stroke="#49565D"
                                    strokeWidth=".75"
                                    d="M10.555 13.449L4.696 13.449"
                                    transform="translate(-113 -534) translate(48 48) translate(48 450) translate(0 23) translate(17.375 13.375)"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const PuzzleIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="18" height="18" viewBox="0 0 18 18">
        <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
            <g stroke="#49565D" strokeWidth=".75">
                <g>
                    <g>
                        <g>
                            <g>
                                <g>
                                    <g>
                                        <g>
                                            <path
                                                d="M9.35 3.074c-.258 0-.502.054-.725.15V0C6.417 0 4.21.843 2.526 2.527.843 4.21.001 6.415 0 8.62h3.173c-.091-.217-.141-.455-.141-.706 0-1.014.822-1.837 1.837-1.837 1.014 0 1.836.823 1.836 1.837 0 .25-.051.489-.142.706h2.062V6.597c.223.096.467.15.725.15 1.014 0 1.837-.822 1.837-1.837 0-1.014-.823-1.836-1.837-1.836z"
                                                transform="translate(-1167 -753) translate(40 485) translate(36 24) translate(4 106) translate(1076 118) translate(1 9) translate(10 11) translate(.375 .38)"
                                            />
                                            <path
                                                fill="currentColor"
                                                d="M17.25 8.62c-.001-2.206-.843-4.411-2.526-6.093C13.04.842 10.832 0 8.624 0v3.224c.224-.097.468-.15.726-.15 1.014 0 1.837.822 1.837 1.836 0 1.015-.823 1.837-1.837 1.837-.258 0-.502-.054-.725-.15V8.62h2.026c-.091.218-.142.457-.142.708 0 1.014.822 1.836 1.837 1.836 1.014 0 1.837-.822 1.837-1.836 0-.251-.052-.49-.142-.708h3.209z"
                                                transform="translate(-1167 -753) translate(40 485) translate(36 24) translate(4 106) translate(1076 118) translate(1 9) translate(10 11) translate(.375 .38)"
                                            />
                                            <path
                                                d="M14.04 8.62c.091.218.142.457.142.708 0 1.014-.822 1.836-1.837 1.836-1.014 0-1.837-.822-1.837-1.836 0-.251.052-.49.142-.708H8.624v2.064c-.225-.098-.473-.155-.734-.155-1.015 0-1.837.822-1.837 1.837 0 1.014.822 1.837 1.837 1.837.261 0 .51-.057.734-.155v3.202c2.208 0 4.415-.842 6.1-2.526 1.685-1.686 2.526-3.895 2.525-6.104H14.04z"
                                                transform="translate(-1167 -753) translate(40 485) translate(36 24) translate(4 106) translate(1076 118) translate(1 9) translate(10 11) translate(.375 .38)"
                                            />
                                            <path
                                                d="M7.89 10.53c.262 0 .51.056.734.154V8.62h-2.06c.09-.217.14-.456.14-.706 0-1.014-.821-1.837-1.835-1.837-1.015 0-1.837.823-1.837 1.837 0 .25.05.49.142.706H0c-.002 2.21.84 4.418 2.526 6.104 1.684 1.684 3.892 2.526 6.098 2.526v-3.202c-.225.098-.473.154-.734.154-1.014 0-1.837-.822-1.837-1.836 0-1.015.822-1.837 1.838-1.837z"
                                                transform="translate(-1167 -753) translate(40 485) translate(36 24) translate(4 106) translate(1076 118) translate(1 9) translate(10 11) translate(.375 .38)"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const VoidAnalysisGotoIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 18 18"
        {...props}
    >
        <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
            <g stroke="#49565D" strokeWidth=".75">
                <g>
                    <g>
                        <g>
                            <path
                                d="M0 4.5V1c0-.552.448-1 1-1h15c.552 0 1 .448 1 1v15c0 .552-.448 1-1 1h-3.5 0"
                                transform="translate(-208.000000, -536.000000) translate(0.000000, 111.000000) translate(207.359862, 421.100000) translate(9.640138, 12.900000) scale(-1, 1) translate(-9.640138, -12.900000) translate(1.140138, 4.400000) translate(8.500000, 8.500000) scale(1, -1) translate(-8.500000, -8.500000)"
                            />
                        </g>

                        <path
                            fill="#D0D0D0"
                            d="M13.837 9.078L3.524 11.084c-.163.032-.27.19-.238.352.024.124.123.22.248.24L13.91 13.32h0l.262 3.966c0 .352.424.532.678.287l5.547-5.744c.41-.396.41-1.044 0-1.44l-5.752-5.547c-.254-.245-.678-.064-.678.289l-.131 3.947z"
                            transform="translate(-208.000000, -536.000000) translate(0.000000, 111.000000) translate(207.359862, 421.100000) translate(11.280345, 11.207604) rotate(-44.000000) translate(-11.280345, -11.207604)"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export interface IconProps {
    className?: string;
    fill?: string;
    style?: CSSProperties;
    rotate?: number;
    onClick?: MouseEventHandler<any> | undefined;
    labelText?: string;
    title?: string;
    alt?: string;
    tabIndex?: number;
}

export const CustomVenueIcon = (props: IconProps) => <Icon component={CustomVenueSvg} {...props} />;

export const RegularArrowIcon = (props: IconProps) => (
    <Icon component={RegularArrowIconSvg} {...props} />
);

export const RecentIcon = (props: IconProps) => <Icon component={RecentIconSvg} {...props} />;

export const AlertIcon = (props: IconProps) => <Icon component={AlertIconSvg} {...props} />;

/**
 * @deprecated use AlertColoredIcon instead
 * TODO: replace all usages with AlertColoredIcon https://placer.atlassian.net/browse/PLAC-17689
 */
export const AlertRedIcon = ({ className, ...props }: IconProps) => (
    <Icon
        component={AlertColoredIconSvg}
        {...props}
        className={classNames(styles.alertRed, className)}
    />
);

/**
 * @deprecated use AlertColoredIcon instead
 * TODO: replace all usages with AlertColoredIcon https://placer.atlassian.net/browse/PLAC-17689
 */
export const AlertOrangeIcon = ({ className, ...props }: IconProps) => (
    <Icon
        component={AlertColoredIconSvg}
        {...props}
        className={classNames(styles.alertOrange, className)}
    />
);

/**
 * @deprecated use CloseIcon instead
 * TODO: replace all usages with CloseIcon https://placer.atlassian.net/browse/PLAC-17689
 */
export const CancelIcon = (props: IconProps) => <Icon component={CancelSvg} {...props} />;

export const DropdownArrowIcon = (props: IconProps) => (
    <Icon component={DropdownArrowSvg} {...props} />
);

export const SearchIcon = (props: IconProps) => <Icon component={SearchIconSvg} {...props} />;

export const ClearSearchIcon = (props: IconProps) => (
    <Icon component={ClearSearchIconSvg} {...props} />
);

export const ChainIcon = (props: IconProps) => <Icon component={ChainIconSvg} {...props} />;

export const HeartIcon = (props: IconProps) => <Icon component={HeartSvg} {...props} />;

export const SelectArrowIcon = (props: IconProps) => <Icon component={SelectArrow} {...props} />;

export const SelectArrowLightIcon = (props: IconProps) => (
    <Icon component={SelectArrowLight} {...props} />
);

export const SmallSelectArrowIcon = (props: IconProps) => (
    <Icon component={SmallSelectArrow} {...props} />
);

export const DownloadIcon = (props: IconProps) => <Icon component={Download} {...props} />;

export const LockIcon = (
    props: IconProps & {
        height?: number;
        width?: number;
    },
) => <Icon component={() => <Lock fill={props.fill} />} {...props} />;

export const HelpIcon = (props: IconProps) => <Icon component={Help} {...props} />;

export const LocationIcon = (props: IconProps) => <Icon component={Location} {...props} />;

export const LocationOutlineIcon = (props: IconProps) => (
    <Icon component={LocationOutlineSvg} {...props} />
);

export const BarChartIcon = (props: IconProps) => <Icon component={BarChart} {...props} />;

export const PieChartIcon = (props: IconProps) => <Icon component={PieChart} {...props} />;

export const TrashBinIcon = (props: IconProps) => <Icon component={TrashBinIconSvg} {...props} />;

export const DotsMoreIcon = (props: IconProps) => <Icon component={DotsMoreIconSvg} {...props} />;

export const CalendarIcon = (props: IconProps) => <Icon component={CalendarIconSvg} {...props} />;

export const PlusIcon = (props: IconProps) => <Icon component={PlusIconSvg} {...props} />;

export const PlusIconThick = (props: IconProps) => (
    <Icon data-testid="plus-icon-thick" component={PlusIconSvgThick} {...props} />
);

export const MinusIconThick = (props: IconProps) => (
    <Icon data-testid="minus-icon-thick" component={minusIconSvgThick} {...props} />
);

export const FilterIcon = (props: IconProps) => <Icon component={FilterIconSvg} {...props} />;

export const CheckMarkIcon = (props: IconProps) => <Icon component={CheckMarkSvg} {...props} />;

export const ArrowOutlinedSvgIcon = (props: IconProps) => (
    <Icon component={ArrowOutlinedSvg} {...props} />
);

export const NoResultsIcon = (props: IconProps) => <Icon component={NoResultsSvg} {...props} />;

export const ClearSelectionIcon = (props: IconProps) => (
    <Icon component={ClearSelectionSvg} {...props} />
);

export const DuplicateIcon = (props: IconProps) => <Icon component={DuplicateIconSvg} {...props} />;

export const PlacerIcon = (props: IconProps) => <Icon component={OwlLogo} {...props} />;

export const ChainsIconRound = (props: IconProps) => (
    <Icon component={ChainsIconRoundSvg} {...props} />
);

export const CalendarIconRound = (props: IconProps) => (
    <Icon component={CalendarIconRoundSvg} {...props} />
);

export const ReportsIconRound = (props: IconProps) => (
    <Icon component={DialogReportIconRoundSvg} {...props} />
);

export const EditIconCopy = (props: IconProps) => <Icon component={EditIconCopySvg} {...props} />;

export const ReportIcon = (props: IconProps) => <Icon component={ReportIconSvg} {...props} />;

export const VarianceIcon = (props: IconProps) => <Icon component={VarianceIconSvg} {...props} />;

export const OverviewIcon = (props: IconProps) => <Icon component={ReportsIconSvg} {...props} />;
export const ArcGisReports = (props: IconProps) => <Icon component={ReportsIconSvg} {...props} />;

export const VisitsIcon = (props: IconProps) => <Icon component={VisitsIconSvg} {...props} />;

export const FlowIcon = (props: IconProps) => <Icon component={FlowIconSvg} {...props} />;

export const TradeAreaIcon = (props: IconProps) => <Icon component={TradeAreaIconSvg} {...props} />;

export const DriveTimeIcon = (props: IconProps) => <Icon component={DriveTimeIconSvg} {...props} />;

export const RankingIcon = (props: IconProps) => <Icon component={RankingIconSvg} {...props} />;

export const LoyaltyIcon = (props: IconProps) => <Icon component={LoyaltyIconSvg} {...props} />;

/**
 * @deprecated please use the LineChartIcon component
 */
export const LineGraphIcon = (props: IconProps) => <Icon component={LineGraphIconSvg} {...props} />;

export const PlusIconCreate = (props: IconProps) => (
    <Icon component={PlusIconCreateSvg} {...props} />
);

export const PlusIconCreateActive = (props: IconProps) => (
    <Icon component={PlusIconCreateActiveSvg} {...props} />
);

export const CreatePoi = (props: IconProps) => <Icon component={CreatePoiSvg} {...props} />;

export const StarIcon = (props: IconProps) => <Icon component={StarIconSvg} {...props} />;

export const StarOutlineIcon = (props: IconProps) => (
    <Icon component={StarOutlineIconSvg} {...props} />
);

export const PopupIllustrationsDelete = (props: IconProps) => (
    <Icon component={PopupIllustrationsDeleteSvg} {...props} />
);

export const FixedDiagramIcon = (props: IconProps) => (
    <Icon component={FixedDiagramSvg} {...props} />
);

export const ProportionalDiagramIcon = (props: IconProps) => (
    <Icon component={ProportionalDiagramSvg} {...props} />
);

export const ChevronIcon = (props: IconProps) => <Icon component={ChevronIconSvg} {...props} />;

export const ChevronCircleIcon = (props: IconProps) => (
    <Icon component={ChevronCircleIconSvg} {...props} />
);

export const AlreadyPurchasedIcon = (props: IconProps) => (
    <Icon component={AlreadyPurchasedIconSvg} {...props} />
);

export const NotificationIcon = (props: IconProps) => (
    <Icon component={NotificationIconSvg} {...props} />
);

export const DemographicsIcon = (props: IconProps) => (
    <Icon component={DemographicsIconSvg} {...props} />
);
DemographicsIcon.__tags = ['demographics', 'audience', 'two people'] as string[];

export const DataFeedIcon = (props: IconProps) => <Icon component={DataFeedIconSvg} {...props} />;

export const OfflineReportsIcon = (props: IconProps) => (
    <Icon component={OfflineReportsIconSvg} {...props} />
);

export const OfflineReportViewMapIcon = (props: IconProps) => (
    <Icon component={OfflineReportViewMapIconSvg} {...props} />
);

export const InfoIcon = ({ className, ...props }: IconProps) => (
    <Icon component={InfoIconSvg} {...props} className={classNames(styles.info, className)} />
);

export const HouseholdCharacteristicsIcon = (props: IconProps) => (
    <Icon component={HouseholdCharacteristicsIconSvg} {...props} />
);

export const CoTenantsIcon = (props: IconProps) => <Icon component={CoTenantsIconSvg} {...props} />;

export const EmptyCreditCountIcon = (props: IconProps) => (
    <Icon component={EmptyCreditCountIconSvg} {...props} />
);

export const CreditCountIcon = (props: IconProps) => (
    <Icon component={CreditCountIconSvg} {...props} />
);

export const FullCreditCountIcon = (props: IconProps) => (
    <Icon component={FullCreditCountIconSvg} {...props} />
);

export const SubmitRequestIcon = (props: IconProps) => (
    <Icon component={SubmitRequestIconSvg} {...props} />
);

export const CircleDownloadIcon = (props: IconProps) => (
    <Icon component={CircleDownloadIconSvg} {...props} />
);

export const EditTableIcon = (props: IconProps) => <Icon component={EditTableIconSvg} {...props} />;

export const GrayOfflineReportIcon = (props: IconProps) => (
    <Icon component={GrayOfflineReportIconSvg} {...props} />
);

export const GrayOfflineReportViewMapIcon = (props: IconProps) => (
    <Icon component={GrayOfflineReportViewMapIconSvg} {...props} />
);

export const PaperClipIcon = (props: IconProps) => <Icon component={PaperClipIconSvg} {...props} />;

export const DownloadSmallIcon = (props: IconProps) => (
    <Icon component={DownloadSmallIconIconSvg} {...props} />
);

export const UploadIcon = (props: IconProps) => <Icon component={UploadIconSvg} {...props} />;

export const PopularityScoreIcon = (props: IconProps) => (
    <Icon component={PopularityScoreIconSvg} {...props} />
);

export const PopularityScoreWhiteIcon = (props: IconProps) => (
    <Icon component={PopularityScoreWhiteIconSvg} {...props} />
);

export const PencilIcon = (props: IconProps) => <Icon component={PencilIconSvg} {...props} />;

export const PuzzleIcon = (props: IconProps) => <Icon component={PuzzleIconSvg} {...props} />;

export const VoidAnalysisGotoIcon = (props: IconProps) => (
    <Icon component={VoidAnalysisGotoIconSvg} {...props} className={classNames(styles.gotoIcon)} />
);

export const GoToIcon = (props: IconProps) => <Icon component={GoToIconSvg} {...props} />;
